{
  "404.message": "Stránka, kterou jste se pokoušeli otevřít, nebyla nalezena. Může to mít následující důvody:",
  "404.message.reason1": "Tato stránka neexistuje.",
  "404.message.reason2": "Stránka existuje, ale nemáte oprávnění pro její zobrazení.",
  "404.nav.dashboard": "Váš dashboard",
  "404.nav.home": "Úvodní stránka",
  "404.nav.title": "Přejít na",
  "404.search.title": "Prohledání stránky",
  "aboutpage.section.title": "Atlassian Confluence Cloud a pluginy Confluence Cloud",
  "accessibility.user.icon": "Ikona uživatele",
  "action.add.comment": "Přidat komentář",
  "action.edit.comment": "Upravit komentář",
  "action.reorder.pages.sentence": "Uspořádat stránky",
  "action.space.addons": "Doplňky",
  "action.space.overview": "Přehled",
  "actions.word": "Akce",
  "add.comment": "Přidat komentář",
  "add.comment.accesskey": "m",
  "add.shortcut": "Přidat zkratku",
  "add.word": "Přidat",
  "addlabels.teamlabels": "Kategorie",
  "adf.translation.error.in.render.description.prod": "Obnovte stránku a zkuste to znovu. Pokud problém přetrává, kontaktujte <a target=\"_blank\" href=\"{link}\">podporu Atlassian</a>.",
  "adf.translation.error.in.render.description.staging": "Chyba ADF zabraňuje zobrazení vašeho obsahu. Podrobněji to můžete prodiskutovat na Slacku v kanálu <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a>.",
  "adf.translation.error.in.render.title.prod": "Váš obsah se nepodažilo zobrazit",
  "adf.translation.error.in.render.title.staging": "Při zobrazování obsahu došlo k chybě ADF",
  "adg3.feedback.placeholder": "Řekněte nám o vašich zkušenostech s použitím softwaru Confluence, abychom jej mohli ještě zlepšit.",
  "adg3.give.feedback": "Poskytnout zpětnou vazbu",
  "adg3.onboarding.docs.link": "Zjistit více",
  "adg3.onboarding.next": "Další",
  "adg3.onboarding.prev": "Předchozí",
  "adg3.onboarding.sidebar.done": "Rozumím",
  "adg3.onboarding.skip": "Přeskočit",
  "adg3.onboarding.start": "Začínáme",
  "adg3.onboarding.step1.content": "Aktualizovali jsme barvy, ikony a písma, takže je jednodušší nalézt důležité věci a vaše oči se nemusejí tolik namáhat.",
  "adg3.onboarding.step1.title": "Seznamte se s novou zkušeností softwaru Confluence",
  "adg3.onboarding.step2.content": "Věci, které nejvíce potřebujete - vyhledávání, vytváření a navigace - najdete všechny v postranním panelu.",
  "adg3.onboarding.step2.title": "Jednoduchá navigace na postranním panelu",
  "adg3.onboarding.step3.content": "Nemůžete si vzpomenout, na čem jste pracovali? Panel vyhledávání vám pomůže se seznamem stránek, které jste nedávno navštívili.",
  "adg3.onboarding.step3.title": "Pokračujte tam, kde jste skončili",
  "adg3.onboarding.step4.content": "Zanechte zpětnou vazbu prostřednictvím svého profilu a pomozte nám se zlepšit. Ještě nejste připraveni na nové zážitky? Tuto možnost můžete také vypnout prostřednictvím svého profilu.",
  "adg3.onboarding.step4.content.no.optout": "Vaše zpětná vazba hraje velkou roli při zlepšování zkušenosti se softwarem [[[Confluence]]]. Sdělte nám svůj názor pomocí vašeho profilu, abyste jej pomohli ještě vylepšit.",
  "adg3.onboarding.step4.title": "Pomozte nám vybudovat nejlepší prostředí Confluence",
  "adg3.onboarding.user.optin.content": "Na základě zpětné vazby jsme provedli změny, ale stále se zlepšujeme. Pokud toho máte více na srdci, zanechte nám poznámku pomocí příkazu Odeslat zpětnou vazbu v postranním panelu.",
  "adg3.onboarding.user.optin.done": "Rozumím",
  "adg3.onboarding.user.optin.title": "Nová zkušenost se softwarem Confluence je tu nyní pro každého",
  "adg3.send.feedback": "Zpětná vazba",
  "adg3.sidebar.button.configure": "Konfigurovat postranní panel",
  "adg3.sidebar.button.done": "Hotolo",
  "adg3.sidebar.button.gotit": "Rozumím",
  "adg3.sidebar.link.disable": "Zakázat",
  "adg3.sidebar.link.enable": "Povolit",
  "adg3.user.profile.other": "Moje Confluence",
  "admin.section.security.title": "Uživatelé a zabezpečení",
  "administration.name": "Administrace",
  "all.updates.mainBanner": "Neděje se nic zajímavého... Zatím",
  "all.updates.subBanner": "Buďte informováni o všem, co se děje na tomto webu. Zde se zobrazí nové stránky, soubory, úpravy a komentáře.",
  "all.updates.subBanner2": "Je čas vytvořit další velkou věc.",
  "all.updates.title": "Všechny aktualizace",
  "anonymous.name": "Anonym",
  "archived.spaces": "Archivované prostory",
  "atlassian.can.contact": "Můžeme vás kontaktovat, abyste mohli navázat na vaši zpětnou vazbu?",
  "atlassian.home.name": "Atlassian Home",
  "attach.files.no.permission": "Budete muset požádat o povolení k vložení souborů zde.",
  "attach.files.tip.close": "OK, rozumím!",
  "attach.files.tip.desc": "Přetáhněte soubory přímo na vaši stránku a vložte je přímo.",
  "attach.files.tip.title": "Tip:",
  "attach.files.upload.files": "Nahrajte soubory",
  "attach.files.upload.images": "Nahrát obrázky",
  "audit.logging.category.user.management": "Uživatelé a skupiny",
  "aui.sidebar.collapse.tooltip": "Sbalit postranní panel ( [ )",
  "aui.sidebar.expand.tooltip": "Rozbalit Postranní panel ( [ )",
  "author.name": "Autor",
  "blog.personal.name": "Osobní blog",
  "blog.post": "Příspěvek na blogu",
  "blog.word": "Blog",
  "blogtree.failed.load.content": "Nepodařilo se načíst příspěvky na blogu",
  "blueprint.navigation.items.create.new.template": "Vytvořit novou šablonu",
  "blueprint.navigation.items.create.new.template.disabled": "Šablony mohou vytvářet pouze administrátoři prostoru",
  "blueprint.navigation.items.filter.for.templates": "Filtrovat šablony",
  "blueprint.navigation.items.page.templates.header": "Šablony stránky",
  "button.cancel": "Zrušit",
  "cache.name.com.atlassian.confluence.pages.Draft": "Koncepty",
  "calendar.share.button.keyboard.shortcut.desc": "Sdílet",
  "calendar3.addcalendar": "Přidat kalendář",
  "calendar3.helptip.learn.more": "Dozvědět se více",
  "calendar3.spacecalendars.header": "Kalendáře",
  "calendar3.spacecalendars.onboarding.button.add.label": "Přidat kalendář",
  "calendar3.spacecalendars.onboarding.intro": "Přidejte kalendář a sledujte přítomnost vašeho týmu, plánujte projekty Jira a zajistěte, aby byli všichni v obraze ohledně důležitých termínů.",
  "calendar3.spacecalendars.onboarding.title": "Zdroj pravdy pro váš tým nebo projekt",
  "cancel.name": "Zrušit",
  "captcha.response.failed": "Zadané slovo neodpovídá textu na obrázku.",
  "categories.name": "Kategorie",
  "changeboarding.dnd.pagetree.spacesettings.banner": "Uspořádání prostoru se zjednodušilo. Nyní si můžete uspořádat stránky na postranní liště jejich přetažením.",
  "changeboarding.dnd.pagetree.spotlight.message": "Přetažením přesuňte stránky a uspořádejte si svůj prostor.",
  "changes-diff.heading.key": "Klíč",
  "changes-diff.these.lines.were.added": "Tento řádek byl přidán.",
  "changes-diff.these.lines.were.removed": "Tento řádek byl odebrán.",
  "changes-diff.this.content.was.modified": "Bylo změněno formátování.",
  "clear.name": "Vymazat",
  "clipboardaccess.browser.not.supported": "Váš prohlížeč nepodporuje vkládání obrázků ze schránky.",
  "clipboardaccess.ok": "OK",
  "close.draft.name": "Zavřít koncept",
  "close.name": "Zavřít",
  "collab.edit.user.limit.msg.body": "<p>Tato stránka je tak populární, že jste dosáhli maximálního počtu současných editorů.</p><p>Zkuste to znovu, když nebude takto zaneprázdněna.</p>",
  "collab.edit.user.limit.msg.title": "Tuto stránku právě teď nemůžete upravovat",
  "collab.status.connected": "Jsme připraveni začít",
  "collab.status.connecting": "Připojuji...",
  "collab.status.error": "Změny nelze uložit",
  "collab.status.tooltip.error": "Zkopírujte svou práci, obnovte stránku a pokusíme se znovu připojit.",
  "collab.status.tooltip.failure": "Nepodařilo se připojit k serveru. Zkontrolujte své připojení k internetu a my se budeme snažit vás připojit.",
  "collab.status.tooltip.success": "Vámi provedené změny automaticky ukládáme",
  "collapse.name": "Sbalit",
  "colourname.property.style.bordercolour": "Hranice a dělení",
  "colourname.property.style.breadcrumbstextcolour": "Text horního panelu",
  "colourname.property.style.headerbuttonbasebgcolour": "Pozadí tlačítka záhlaví",
  "colourname.property.style.headerbuttontextcolour": "Text tlačítka záhlaví",
  "colourname.property.style.headingtextcolour": "Text záhlaví",
  "colourname.property.style.linkcolour": "Odkazy",
  "colourname.property.style.menuitemselectedbgcolour": "Vybrané pozadí položky v menu",
  "colourname.property.style.menuitemselectedtextcolour": "Vybraný text položky v nabídce",
  "colourname.property.style.menuitemtextcolour": "Text položky nabídky stránky",
  "colourname.property.style.menuselectedbgcolour": "Vybrané pozadí nabídky stránky",
  "colourname.property.style.navbgcolour": "Pozadí karty navigace",
  "colourname.property.style.navselectedbgcolour": "Zvýraznění pozadí navigačního panelu",
  "colourname.property.style.navselectedtextcolour": "Zvýraznění navigačního textu karty",
  "colourname.property.style.navtextcolour": "Text navigace karty",
  "colourname.property.style.searchfieldbgcolour": "Pozadí vyhledávacího pole",
  "colourname.property.style.searchfieldtextcolour": "Text pole vyhledávání",
  "colourname.property.style.spacenamecolour": "Text názvu prostoru",
  "colourname.property.style.topbarcolour": "Horní panel",
  "colourname.property.style.topbarmenuitemtextcolour": "Text položky v horní části nabídky",
  "colourname.property.style.topbarmenuselectedbgcolour": "Vybrané pozadí nabídky horního panelu",
  "colourname.property.style.topbarmenuselectedtextcolour": "Zvolený text nabídky horního panelu",
  "com.atlassian.confluence.contributors.contributors.label": "Přispěvatelé",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "Zobrazit soubor",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Máme to, díky!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Upravit stránku",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Roadmap Planner",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Strom stránek",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Filtrovat",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Tip: zadejte kdekoliv „g“ a poté „r“ pro rychlé otevření této nabídky",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Nedávno zobrazené stránky",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Stav",
  "com.atlassian.mywork.header.notifications": "Upozornění",
  "comment.display.name.anonymous": "Anonymní",
  "comment.edit": "Upravit",
  "comment.edited": "Upraveno",
  "comment.name.tooltip": "Přidat komentář",
  "comment.notification.enable": "Sledujte tuto stránku",
  "comment.permalink": "Trvalý odkaz",
  "comment.plural": "{0} komentářů",
  "comment.remove": "Odstranit",
  "comment.reply": "Odpovědět",
  "comment.singular": "1 komentář",
  "compare.selected": "Porovnejte vybrané verze",
  "configuration.name": "Konfigurace",
  "confluence.extra.attachments.attachments.label": "Přílohy",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "Page Properties Report",
  "confluence.home": "Domovská stránka Confluence",
  "confluence.macros.advanced.children.label": "Zobrazení podřazených položek",
  "confluence.macros.advanced.contentbylabel.label": "Obsah podle štítku",
  "confluence.macros.advanced.recently-updated.label": "Nedávno aktualizované",
  "confluence.mobile.nav.switch.to.mobile.action": "Přepněte se do mobilní verze softwaru Confluence",
  "confluence.mobile.nav.switch.to.mobile.text": "Prohlížíte verzi pro stolní počítače v mobilním zařízení.",
  "confluence.mobile.refresh": "Aktualizovat",
  "confluence.request.access.pagerestricted.inherited.description": "Je to proto, že dědí omezení z nadřazené stránky. Správce prostoru nebo osoba, která tuto stránku sdílela, vám může poskytnout přístup.",
  "confluence.request.access.pagerestricted.request.access.button": "Požádat o přístup",
  "confluence.request.access.pagerestricted.requestaccess.description": "Klepněte na tlačítko vyžádat přístup a my najdeme někoho, kdo vám přístup může udělit.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "Nemáte oprávnění k úpravě této stránky",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "Nemáte oprávnění k zobrazení této stránky",
  "confluence.user.profile.department": "Oddělení",
  "confluence.user.profile.location": "Umístění",
  "confluence.user.profile.position": "Pozice",
  "connect.addon.wait.or": "Čekat nebo",
  "content.empty": "Text komentáře je prázdný. Nelze vytvořit prázdné komentáře.",
  "content.kind.decisions": "Rozhodnutí",
  "content.kind.file-list": "Seznam souborů",
  "content.kind.jirareport": "Zpráva Jira",
  "content.kind.kb-how-to-article": "Jak napsat článek",
  "content.kind.kb-troubleshooting-article": "Poradce při potížích",
  "content.kind.meeting-notes": "Poznámky o schůzkách",
  "content.kind.product-requirements": "Požadavky produktu",
  "content.kind.retrospective": "Retrospektivní",
  "content.kind.shared-links": "Sdílené odkazy",
  "content.kind.task-report": "Zpráva o úloze",
  "content.type.attachment": "Přílohy",
  "content.type.blogpost": "Novinky",
  "content.type.page": "Stránky",
  "cq.header.title": "Otázky",
  "create.blog.post.event.description": "Vytvořte novinový příspěvek",
  "create.drawer.header": "Vytvořit",
  "create.drawer.page.selector.all.pages.in.space": "Všechny stránky v tomto prostoru",
  "create.drawer.page.selector.location.header": "Umístění",
  "create.drawer.page.selector.no.page.found": "Nebyly nalezeny žádné stránky.",
  "create.drawer.page.selector.no.parent.page": "Žádná nadřazená stránka",
  "create.drawer.page.selector.pages.loading": "Načítání stránek",
  "create.drawer.page.selector.parent.page": "Nadřazená stránka",
  "create.drawer.page.selector.parent.page.tooltip.help": "Blogy, kalendáře a otázky se pod nadřazenou stránkou neobjeví",
  "create.drawer.page.selector.recent.pages": "Nedávné stránky",
  "create.drawer.page.selector.select.parent.page": "Vyberte nadřazenou stránku",
  "create.drawer.space.selector.header": "Prostor",
  "create.drawer.space.selector.location.header": "Umístění",
  "create.drawer.space.selector.no.space.found": "Nebyly nalezeny žádné prostory",
  "create.drawer.space.selector.recent.spaces": "Nedávné prostory",
  "create.drawer.space.selector.search.spaces": "Všechny prostory",
  "create.drawer.space.selector.select.a.space": "Vybrat prostor",
  "create.drawer.space.selector.spaces.loading": "Načítání prostorů",
  "create.drawer.space.selector.starred.spaces": "Prostory označené hvězdičkou",
  "create.drawer.template.failed.to.load.atlassian.support": "podporu Atlassian.",
  "create.drawer.template.failed.to.load.content": "Obnovte stránku a zkuste to znovu. Pokud problém přetrvává, kontaktujte",
  "create.drawer.template.failed.to.load.title": "Šablonu se nepodařilo načíst",
  "create.name": "Vytvořit",
  "css.file": "Soubor CSS",
  "current.space": "Aktuální prostor",
  "default.space.homepage.title": "{0} Domů",
  "delete.name": "Odstranit",
  "desc.colourscheme": "Následující barvy lze přizpůsobit pro toto barevné schéma.",
  "description.name": "Popis",
  "discard.name": "Zahodit",
  "discover.applications": "Prozkoumat aplikace",
  "draft": "Koncept",
  "draft.no.content": "Tento návrh nemá žádný obsah.",
  "edit.comment": "Upravit komentář",
  "edit.labels": "Přidat štítky",
  "editor-help.fabric.help.center.feedback.item": "Zpětná vazba",
  "editor.adf.parsing.error.details": "Podrobnosti o chybě:",
  "editor.adf.parsing.error.message.prod": "Obnovte stránku a zkuste to znovu. Pokud problém přetrává, kontaktujte <a target=\"_blank\" href=\"{link}\">podporu Atlassian</a>.",
  "editor.adf.parsing.error.message.staging": "Náš tým byl upozorněn, ale také o tom můžete diskutovat na Slacku v kanálu <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a>.",
  "editor.adf.parsing.error.title.prod": "Editor se nepodařilo načíst.",
  "editor.adf.parsing.error.title.staging": "Došlo k problému při konverzi tohoto dokumentu do ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} Přílohy",
  "editor.attachments.singular": "{0} Příloha",
  "editor.attachments.zero": "Přílohy",
  "editor.autocomplete.file.header.text": "Návrhy souborů",
  "editor.autocomplete.links.create.link": "Vložte odkaz pro vytvoření stránky",
  "editor.autocomplete.links.dialog.search": "Vyhledávejte ‘{0}’",
  "editor.autocomplete.links.dialog.search.no.text": "Vyhledat",
  "editor.autocomplete.links.header.text": "Návrhy odkazů",
  "editor.autocomplete.links.web.link": "Vložte webový odkaz",
  "editor.autocomplete.macros.dialog.browse": "Otevřete prohlížeč maker",
  "editor.autocomplete.macros.error.load.header": "Nepodařilo se získat podrobnosti o makru",
  "editor.autocomplete.macros.error.load.retrylink": "Zkuste to znovu",
  "editor.autocomplete.macros.header.text": "Návrhy maker",
  "editor.autocomplete.media.files.dialog.browse": "Otevřít knihovnu souborů",
  "editor.autocomplete.media.header.text": "Návrhy médií",
  "editor.autocomplete.media.images.dialog.browse": "Otevřít obrázek prohlížeče",
  "editor.autocomplete.media.macros.dialog.browse": "Vložte jiné médium",
  "editor.autoformat.sampletext.firstcell": "první buňka",
  "editor.autoformat.sampletext.heading": "záhlaví",
  "editor.buttons.disable.by.empty.title.tooltip": "Vaše stránka potřebuje název předtím, než bude zveřejněna.",
  "editor.buttons.disable.by.not.saving.tooltip": "Stále se pracuje…",
  "editor.buttons.disable.by.saving.tooltip": "Stále vaši stránku ukládáme.",
  "editor.cancel.discard.changes.confirmation": "Zahodit změny",
  "editor.cancel.discard.changes.message": "Veškerý vložený obsah bude vymazán. Prosíme o potvrzení.",
  "editor.cancel.discard.changes.title": "Potvrďte zahození všech změn",
  "editor.cant.publish.changes": "Změny nelze publikovat",
  "editor.change.comment": "Co jste změnili?",
  "editor.close.publish.tooltip": "Uložit změny bez publikování",
  "editor.close.update.tooltip": "Uložit změny bez aktualizace",
  "editor.collab.user.limit.body": "Tato stránka je tak populární, že jste dosáhli maximálního počtu souběžných editorů. Zkuste to znovu, až nebude tak vytížená.",
  "editor.collab.user.limit.title": "Tuto stránku nelze nyní upravit",
  "editor.collaborative-editing.load.error": "Načítání editoru trvá déle než obvykle. Chvíli počkejte a pokud se stránka stále nenačítá, obnovte ji. Pokud se problém nevyřeší, kontaktujte svého správce prostoru Confluence.",
  "editor.collaborative-editing.refresh-editor.error": "Při načítání editoru došlo k chybě, zkuste to prosím znovu.",
  "editor.collaborative.mode.disabled": "Kolaborativní editace je momentálně offline. Zkopírujte svou práci a poté aktualizujte stránku, abyste mohli pokračovat v úpravách.",
  "editor.collaborative.mode.enabled": "Kolektivní úprava byla vypnuta, ale nyní je opět v provozu. Pro pokračování v úpravách zkopírujte své změny a obnovte stránku.",
  "editor.content.appearance.toggle.fixed.width": "Upravit stránku na celou šířku",
  "editor.content.appearance.toggle.full.width": "Upravit stránku na pevnou šířku",
  "editor.content.placeholder.11": "Věděli jste, že na tuto stránku můžete přidávat nejrůznější vychytávky, například tabulku obsahů, datum nebo roadmapu? Zadáním symbolu / otevřete seznam.",
  "editor.content.placeholder.ai": "Chcete-li využít Atlassian Intelligence, zadejte text „/ai“, chcete-li přidat prvky, zadejte znak „/“, a chcete-li někoho zmínit, zadejte znak „@“ (dotyčnému dáme vědět).",
  "editor.content.placeholder.bpqa": "Zadáním znaku „/“ zobrazíte seznam prvků, pomocí znaku „@“ můžete někoho zmínit nebo si můžete vybrat níže:",
  "editor.content.placeholder.bpqa.ai": "Chcete-li využít Atlassian intelligence, zadejte text „/ai“, chcete-li přidat prvky, zadejte znak „/“, chcete-li někoho zmínit, zadejte znak „@“ nebo si můžete vybrat níže:",
  "editor.content.placeholder.easy.mentions": "Zadáním znaku „/“ zobrazíte všechny prvky, pomocí znaku „@“ můžete někoho zmínit.",
  "editor.content.placeholder.slash": "Zadáním znaku / můžete vložit jakýkoli element",
  "editor.content.placeholder.slash.bracket": "Jakýkoli element můžete rychle vložit zadáním znaku /",
  "editor.content.reconciliation.error.details": "Podrobnosti o chybě:",
  "editor.content.reconciliation.error.fatal.prod": "Náš tým byl upozorněn. Pár minut počkejte a zkuste to znovu. Pokud problém přetrvává, kontaktujte podporu Atlassian.",
  "editor.content.reconciliation.error.fatal.staging": "Náš tým byl upozorněn, ale také o tom můžete diskutovat na Slacku v kanálu #cc-content-experience.",
  "editor.content.reconciliation.error.retrying": "Další pokus za {0} ...",
  "editor.content.reconciliation.error.title": "Tuto stránku se nepodařilo načíst",
  "editor.content.reconciliation.networkerror.fatal.prod": "Tento problém by mělo vyřešit obnovení stránky. Pokud problém přetrvává, kontaktujte <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">podporu Atlassian</a> nebo administrátora prostoru.",
  "editor.content.reconciliation.networkerror.title": "Při načítání vašeho obsahu se vyskytl problém",
  "editor.discard-on-close.tooltip": "Zahodit prázdný koncept",
  "editor.discard-to-published.button.label": "Zahodit",
  "editor.discard-to-published.button.tooltip": "Vrátit na poslední publikovanou verzi stránky",
  "editor.discard-to-published.dialog.title": "Zahodit nepublikované změny?",
  "editor.discard-to-published.dialog.warning": "Tímto obnovíte editor na poslední publikovanou verzi této stránky. Pokud má někdo jiný nepublikované změny na stránce, zahodíte také tyto změny.",
  "editor.discard-to-published.error.message": "Momentálně nedokážeme získat poslední publikovanou verzi stránky. Dejte mu chvíli a zkuste návrh znovu zahodit.",
  "editor.discard-to-published.error.title": "Nelze vrátit na poslední publikovanou verzi",
  "editor.discard-to-published.success.message": "Proběhl úspěšný návrat na poslední publikovanou verzi",
  "editor.draft.can.be.migrated": "Kolaborativní úprava je zde! Abyste mohli pokračovat v práci na této stránce, musíme přenést obsah do nového konceptu.<br> <a href={0}>Přenést nyní</a>",
  "editor.dynamic-macro.preview.limit.desc": "Náhled dynamického makra v konceptu je plně podporován pouze při povolení sdíleného návrhu.",
  "editor.ellipsis.blog.delete": "Smazat nepublikovaný příspěvek na blogu",
  "editor.ellipsis.import-document": "Otevřít šablonu a importovat dokument",
  "editor.ellipsis.open.template.browser": "Otevřít prohlížeč šablony",
  "editor.ellipsis.open.templates.and.import": "Otevřít šablony a importovat dokument",
  "editor.ellipsis.page.delete": "Smazat nepublikovanou stránku",
  "editor.ellipsis.remove": "Vrátit na poslední publikovanou verzi",
  "editor.ellipsis.resolved.comments": "Vyřešené komentáře",
  "editor.ellipsis.view-changes": "Zobrazit změny",
  "editor.error.delayed.publishing": "Budeme se nadále pokoušet o publikování. Pokud to potrvá moc dlouho, obnovte stránku a klikněte na tlačítko <strong>Publikovat</strong>.",
  "editor.error.delayed.publishing.title": "Při publikování vašeho obsahu se vyskytl problém.",
  "editor.excerpt.include.macro.error": "Chyba při načítání výňatku z „{0}“.",
  "editor.excerpt.panel.title.loading": "Načítání...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Příspěvek na blogu bez názvu",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Stránka bez názvu",
  "editor.fabric.share.invite.to.edit.form.title": "Pozvat k upravování",
  "editor.files.may.be.uploading": "Je možné, že se některé soubory stále nahrávají. Chvíli počkejte a pak to zkuste znovu. Pokud to nebude fungovat, obnovte stránku a znovu načtěte všechny soubory, které se zdály před publikováním poškozené.",
  "editor.generic.refresh": "Něco se stalo s editorem. Pro pokračování v úpravách zkopírujte své neuložené změny a obnovte stránku.",
  "editor.go.back": "Zpět",
  "editor.heartbeat.unauthorised.warning.generic.body": "Tento obsah byl přesunut, omezen nebo smazán. Doporučujeme zkopírovat vše potřebné a uzavřít editor.",
  "editor.heartbeat.unauthorised.warning.generic.title": "Žádný přístup na tuto stránku",
  "editor.heartbeat.unauthorised.warning.page-move.body": "Nemůžete publikovat kvůli přesunu stránky nebo změně omezení. Doporučujeme zkopírovat vše potřebné a uzavřít editor.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "Oprávnění stránky byla změněna",
  "editor.help.how.to.use.blueprint": "Jak používat {blueprintType}",
  "editor.help.templates": "Použití šablon stránek",
  "editor.help.updates": "Úpravy aktualizací",
  "editor.help.updates.1.description": "První fáze vylepšeného editování se týká blogových příspěvků. Reaktivnější obsah, lepší práce s obrázky a jednodušší rozhraní. Abyste si tyto vlastnosti vyzkoušeli, vytvořte nový blogový příspěvek.",
  "editor.help.updates.1.title": "Blogové příspěvky",
  "editor.help.updates.2.description": "Do vašich poznámek ze schůzek bylo nyní přidáno nové editační rozhraní. Mezi nejnovější aktualizace patří rozšířená funkce tabulek, kterou lze přepínat kliknutím na tabulku, a zvýšení rychlosti a spolehlivosti.",
  "editor.help.updates.2.title": "Poznámky ze schůzky",
  "editor.hints.close": "Zavřít rady",
  "editor.hints.next": "Další tip",
  "editor.labels": "{0}",
  "editor.labels.desc": "Upravit popisky stránek",
  "editor.labels.plural": "{0} Štítky",
  "editor.labels.singular": "{0} Štítek",
  "editor.labels.zero": "Štítky",
  "editor.learn.more": "Zjistit více",
  "editor.location.desc": "Přidat umístění",
  "editor.minor.edit": "Upozorněte pozorovatele",
  "editor.offline.before.save.error": "Nelze komunikovat se serverem. Uložení momentálně není možné.",
  "editor.offline.preview.error": "Nelze se dostat na server. Zkontrolujte své připojení k internetu a také funkčnost softwaru Confluence.",
  "editor.offline.save.error": "Komunikace se serverem selhala. Ukládání není v tuto chvíli možné.",
  "editor.offline.save.error.generic": "Při zpracování žádosti došlo k chybě.",
  "editor.offline.save.noauthorized": "Vaše relace vypršela. Chcete-li pokračovat v práci, budete se muset znovu přihlásit nebo přepnout na jiný účet.\n <div><a href=\"/login?application=confluence\">Přihlásit se nebo přepnout na jiný účet</a></div>",
  "editor.offline.save.noauthorized.title": "Nelze se připojit k serveru",
  "editor.offline.save.page.exist.content": "Stránka s názvem '{'0'}' už v tomto prostoru existuje. Zadejte jiný název.",
  "editor.onboarding.draft.placeholder": "Zadáním znaku „/“ zobrazíte seznam užitečných elementů, které lze přidat na stránku (například obsah nebo roadmapa).<br/>Případně, pokud máte momentálně v mysli stejné prázdno, jako je na této stránce, můžete začít pomocí jedné ze šablon vpravo →",
  "editor.onboarding.spotlight.body": "Zjistěte, co se změnilo a proč.",
  "editor.onboarding.spotlight.finish": "Je to jasné",
  "editor.onboarding.spotlight.title": "Vaše šablony postupně aktualizujeme",
  "editor.onboarding.step1.content": "Pracujeme na poskytování funkcí, o které jste žádali, počínaje lepší čitelností, inteligentnějšími formátovacími nástroji a modernějším vzhledem. <br /><a href=''{linkCAC}' target='_blank'>Více informací o změnách</a>",
  "editor.onboarding.step1.title": "Přátelštější příspěvky na blogu",
  "editor.onboarding.step2.content": "Vaše nejčastěji používané funkce se nacházejí na panelu nástrojů, zatímco pokročilejší nástroje jsou pod znaménkem plus. Také máte k dispozici spoustu nových emoji, které vám rozjasní den! <br/><a href=''{linkCAC}' target='_blank'>Více informací o změnách</a>",
  "editor.onboarding.step2.title": "Hledáte něco?",
  "editor.onboarding.step3.content": "Tato práce je nedokončená a potřebujeme vaši pomoc, aby vzniklo něco úžasného. Pošlete nám svůj názor a sledujte <a href=''{linkCAC}' target='_blank'>stránku Confluence</a>, aby vám nrunikly žádné změny. <br/><a href=''{linkCAC}' target='_blank'>Více informací o změnách</a>",
  "editor.onboarding.step3.title": "Vytvořme spolu něco úžasného",
  "editor.page.can.not.be.accessed.message": "Vaše relace mohla vypršet. Chcete-li pokračovat v práci, budete se muset znovu přihlásit nebo přepnout na jiný účet.\n <div><a href=\"/login?application=confluence\">Přihlásit se nebo přepnout na jiný účet</a></div>",
  "editor.page.can.not.be.accessed.title": "Tento obsah není přístupný.",
  "editor.page.conflict.message": "Aktualizujte stránku, abyste zkusili znovu navázat spojení.",
  "editor.page.conflict.title": "Nelze synchronizovat se serverem.",
  "editor.page.is.too.big": "Tato stránka je příliš velká na to, aby byla uložena. Můžete ji rozdělit na několik stránek a poté použít <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">makro k zahrnutí stránky</a>, abyste obsah zobrazili.",
  "editor.page.is.trashed.message": "Zkopírujte obsah a přidejte jej na novou stránku nebo <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">obnovte tuto stránku z koše</a> a zkuste to znovu.</div>",
  "editor.page.is.trashed.title": "Tento obsah byl vymazán",
  "editor.page.legacy.draft.deprecated": "Kolaborativní úprava je zde! To znamená, že od vás potřebujeme trochu spolupráce, abychom mohli restartovat editační relaci. Vše, co musíte udělat, je zkopírovat obsah, znovu upravit tuto stránku, poté obsah vložit a uložit.",
  "editor.page.moved.message.body": "Nic se však neděje - vaše změny můžete zveřejnit, až budete připraveni. <br /><br /> Nové umístění: {0}",
  "editor.page.moved.message.title": "{0} přesunul/a tuto stránku",
  "editor.page.moved.message.unknown.mover": "Jiný uživatel",
  "editor.placeholder.broken.image": "Nefunkční obrázek",
  "editor.placeholder.broken.link": "Poškozený odkaz",
  "editor.placeholder.broken.macro": "Nefunkční makro",
  "editor.placeholder.error": "Chyba",
  "editor.preview.error": "Při načítání náhledu došlo k chybě. Prosím, zkuste to znovu později.",
  "editor.publish.blog": "Zveřejnit",
  "editor.publish.blog.desc": "Publikujte svůj příspěvek na blogu",
  "editor.publish.external.share.label": "Externě sdíleno",
  "editor.publish.hotkey.description": "Chcete-li publikovat tento obsah, použijte kombinaci kláves {keyCombination}.",
  "editor.publish.with.comment": "Publikovat s komentářem verze…",
  "editor.publish.without.notify": "Publikovat bez oznámení sledujícím",
  "editor.quit-dialog.button.delete.blog.exit": "Odstranit příspěvek na blogu",
  "editor.quit-dialog.button.delete.page.exit": "Odstranit stránku",
  "editor.quit-dialog.button.discard.changes.by.many": "Zrušit změny <strong>všech uživatelů</strong>",
  "editor.quit-dialog.button.discard.changes.by.one": "Zrušit <strong>všechny</strong> změny",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Zahodit všechny nepublikované změny",
  "editor.quit-dialog.button.discard.limited.tooltip": "Společná editace je deaktivována. Změny můžete zahodit, když dojde k její opětovné aktivaci.",
  "editor.quit-dialog.button.revert.blog.exit": "Stáhnout příspěvek na blogu",
  "editor.quit-dialog.button.revert.page.exit": "Vrátit stránku",
  "editor.quit-dialog.button.save.exit": "Ponechat koncept",
  "editor.quit-dialog.cancel.changes.by.many": "<p>Spolu s ostatními lidmi jste provedli změny, které zatím nebyly publikovány. </p>\n<p>Pokud zrušíte změny, odstraníte změny provedené následujícími lidmi a vrátíte se k poslední publikované verzi této stránky. Pokud tak určíte, nebudou moci obnovit svoji práci.</p>\n\n<p>Tito lidé provedli změny:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>Provedli jste změny, které zatím nebyly publikovány.</p><p>Pokud zrušíte změny, vaše nepublikované změny budou odstraněny. Tuto akci nemůžete vrátit zpět.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "Tímto natrvalo odstraníte tento příspěvek na blogu, na kterém jste vy a ostatní lidé pracovali.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "Jakmile odstraníte nepublikovaný blogový příspěvek, zmizí nadobro.",
  "editor.quit-dialog.delete.page.changes.by.many": "Tímto natrvalo odstraníte tuto stránku, na které jste vy a ostatní lidé pracovali.",
  "editor.quit-dialog.delete.page.changes.by.one": "Pokud odstraníte nepublikovanou stránku, zmizí nadobro.",
  "editor.quit-dialog.last.edited": "Naposledy upraveno",
  "editor.quit-dialog.link.hide.diff": "Skrýt změny",
  "editor.quit-dialog.link.show.diff": "Zobrazit změny",
  "editor.quit-dialog.publish.changes": "<p>Byly provedeny změny, které jste vy a ostatní lidé dosud nezveřejnili.</p><p>Tito lidé provedli změny:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "Tímto natrvalo odstraníte všechny změny, které jste provedli od zveřejnění tohoto příspěvku na blogu",
  "editor.quit-dialog.revert.changes.by.many": "Tímto způsobem budou trvale odstraněny všechny změny provedené následujícími uživateli od okamžiku publikace této stránky.",
  "editor.quit-dialog.revert.page.changes.by.one": "Tímto natrvalo odstraníte všechny změny, které jste provedli od zveřejnění této stránky.",
  "editor.quit-dialog.title.blogpost.delete": "Smazat nepublikovaný příspěvek na blogu?",
  "editor.quit-dialog.title.discard": "Vrátit na poslední publikovanou verzi?",
  "editor.quit-dialog.title.exit": "Zavřete editor",
  "editor.quit-dialog.title.page.delete": "Smazat nepublikovanou stránku?",
  "editor.quit-dialog.title.publish": "Publikovat stránku?",
  "editor.restrictions.desc": "Upravit omezení stránky",
  "editor.return.to.edit": "Vraťte se do režimu úprav",
  "editor.satisfaction.survey.description": "Jak se vám pracovalo na úpravách?",
  "editor.satisfaction.survey.final.description": "Vaše zpětná vazba byla odeslána",
  "editor.satisfaction.survey.final.title": "Děkujeme",
  "editor.satisfaction.survey.question.bad": "To je nám líto. Co se pokazilo? (volitelné)",
  "editor.satisfaction.survey.question.good": "Děkujeme! Co se vám na tom líbilo? Co by šlo zlepšit? (volitelné)",
  "editor.satisfaction.survey.title": "Vaše stránka byla publikována",
  "editor.save.draft.desc": "Uložte svůj návrh",
  "editor.save.page.desc": "Uložte svoji stránku",
  "editor.shared.draft.done.desc": "Uložit koncept; pokud je prázdný, zahodit",
  "editor.shared.draft.publish.desc": "Publikujte změny",
  "editor.shared.draft.update.desc": "Aktualizujte publikovanou stránku",
  "editor.shortcuts": "Upravování klávesových zkratek",
  "editor.synchrony.publish-page.message": "{0} publikoval/a tuto stránku.",
  "editor.template.changing.variable.dialog.title": "Upravit proměnnou šablony",
  "editor.template.variable.input.creation.error.action": "Navštivte podporu Atlassian",
  "editor.template.variable.input.creation.error.description": "Obnovte stránku a zkuste to znovu. Pokud problém přetrvává, dejte nám vědět prostřednictvím odkazu níže.",
  "editor.template.variable.input.creation.error.title": "Něco se pokazilo",
  "editor.template.variable.list.field.placeholder": "možnost 1, možnost 2, možnost 3",
  "editor.template.variable.name.field": "Název proměnné",
  "editor.title.is.empty": "Než zmáčknete tlačítko zveřejnění, přidejte nadpis stránky.",
  "editor.title.is.empty.title": "Tato stránka potřebuje jméno",
  "editor.title.placeholder": "Název stránky",
  "editor.title.too.long": "Nadpis nesmí být delší než 255 znaků.",
  "editor.unavailable.generic.body": "Editace je momentálně nedostupná. Zkuste to znovu za pár minut.",
  "editor.unavailable.title": "Nelze upravit",
  "editor.unpublished.changes.lozenge.label": "Nepublikováno",
  "editor.unpublished.changes.lozenge.tooltip": "Tato stránka obsahuje nepublikované změny",
  "editor.waiting.to.publish.changes": "Možná stále probíhá nahrávání souboru.",
  "editor.waiting.to.publish.changes.title": "Vydržte prosím, tohle chvíli potrvá.",
  "email.text.added.by": "Přidáno",
  "error.connection.lost.body": "Počkáme, až se znovu připojíte.",
  "error.connection.lost.title": "Vypadá to, že jste ztratili své připojení.",
  "error.connection.recovered.action": "Znovu načtěte obsah",
  "error.connection.recovered.title": "Znovu připojeno",
  "error.notfound.title": "Je nám líto, tuto stránku nemůžeme najít.",
  "error.recovery.body": "Vaše změny jsou v bezpečí. Obnovte stránku a zkuste to znovu.",
  "error.recovery.title": "Při načítání editoru se vyskytl problém",
  "error.server-error.body": "Zkuste to později.",
  "error.server-error.title": "Něco se pokazilo.",
  "error.session.expired.body": "Příště budeme lepší, slibujeme.",
  "error.session.expired.title": "Zdá se, že jsme ztratili relaci.",
  "excel.file": "Tabulka Microsoft Excel",
  "excel.macro.file": "Tabulka Microsoft Excel s povolenými makry",
  "excel.template.file": "Šablona aplikace Microsoft Excel",
  "excel97.file": "List aplikace Microsoft Excel",
  "excel97.template.file": "Šablona aplikace Microsoft Excel 97",
  "existing.blogpost.placeholder": "Titulek příspěvku na blogu",
  "expand-macro.default-title": "Klikněte sem pro rozbalení...",
  "expand.name": "Rozbalit",
  "fabric.editor.announcement.datednotice.main": "{0} přejdete na nový zážitek z upravování.",
  "fabric.editor.announcement.dismiss": "Zavřít",
  "fabric.editor.announcement.greeting": "Dobrý den, {0}.",
  "fabric.editor.announcement.initialnotice.main": "Za pár týdnů se způsob, jakým vytváříte obsah v Confluence, změní.",
  "fabric.editor.announcement.link.action": "Zjistěte, co se změnilo a jaké nové funkce máte k dispozici.",
  "fabric.editor.announcement.rollbacknotice.action": "Přečtěte si oznámení o tom, jak vrátit existující stránky do starého rozhraní.",
  "fabric.editor.announcement.rollbacknotice.main": "Vaše stránky byly nedávno omylem aktualizovány na nové editační rozhraní. Tuto změnu jsme vrátili zpět.",
  "fabric.editor.announcement.tryit.action": "Zkuste to na nové stránce.",
  "fabric.editor.announcement.tryitnotice.main": "V novém editačním rozhraní budou stránky vypadat lépe a budete moci používat nové funkce jako třeba živá makra.",
  "fabric.editor.changeboarding.banner.action": "Podívejte se, jaké nové věci jsme pro vás připravili.",
  "fabric.editor.changeboarding.banner.dismiss": "Zavřít",
  "fabric.editor.changeboarding.banner.main": "Dobrý den, {0}, provádíme určité změny, abychom vám pomohli vytvořit lépe vypadající a čitelnější obsah.",
  "fabric.editor.page.removed.description": "Obnovte teď stránku.",
  "fabric.editor.page.removed.title": "Tato stránka byla nedávno archivována nebo odstraněna",
  "fabric.editor.permission.removed.description": "Omezení na této stránce byla změněna. Obraťte se o pomoc na svého administrátora.",
  "fabric.editor.permission.removed.title": "Tuto stránku vám nemůžeme zobrazit",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Rozbalí <strong>všechny prvky stránky</strong> vodorovně, což redukuje bílá místa. Přepnutím můžeme obsah stránky vrátit zpět na pevnou šířku.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Nastavte <strong>každý sloupec nebo tabulku</strong> a většinu <strong>maker</strong> jako široké nebo na celou šířku. Můžete také vybrané jednotlivé prvky nastavit na pevnou šířku.</p>",
  "fabric.full.width.help.center.tableElement.title": "Přepínání jednotlivých prvků",
  "fabric.help.center.columns.details": "<p>Přidejte <strong>sloupec</strong> na vaši stránku a poté použijte <strong>plovoucí nabídku</strong>, abyste přepnuli mezi 2 nebo 3 konfiguracemi sloupce.</p>",
  "fabric.help.center.columns.title": "Sloupce",
  "fabric.help.center.dialog.title": "Naučte se základy",
  "fabric.help.center.imageDisplay.details": "<p>Vyberte obrázek, poté ho tažením <strong>okrajů</strong> upravte, nebo použijte <strong>plovoucí nabídku</strong> a změňte jeho zarovnání.</p>",
  "fabric.help.center.imageDisplay.title": "Zobrazení obrázku",
  "fabric.help.center.layouts.details": "<p>Použijte <kbd>←</kbd> <kbd>→</kbd> ke změně rozvržení sloupců, tabulek a maker.</p><p>Vyberte si mezi <strong>pevnou šířkou</strong>, která na všech obrazovkách zůstane stejná, <strong>plnou šířkou</strong>, která se roztáhne a vyplní prostor, nebo středním nastavením <strong>šířky</strong>.</p>",
  "fabric.help.center.layouts.title": "Rozložení",
  "fabric.help.center.menuitem.title": "Kurz",
  "fabric.help.center.slashCommands.details": "<p>Pro otevření nabídky a vložení obsahu, jako jsou <strong>tabulky</strong>, <strong>makra</strong> a <strong>data</strong>, během vytváření stránky napište <kbd>/</kbd>.",
  "fabric.help.center.slashCommands.title": "Příkazy s lomítkem",
  "fabric.help.center.spotlight.body": "Kdykoli se sem můžete vrátit a znovu si kurz projít.",
  "fabric.help.center.spotlight.header": "Potřebujete si osvěžit znalosti?",
  "fabric.help.center.tableManipulation.details": "<p>Upravujte nebo formátujte tabulky z <strong>okrajů tabulky</strong>, <strong>rozbalovacího seznamu</strong> a <strong>plovoucí nabídky</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Manipulace s tabulkou",
  "fabric.help.center.templates.details": "<p>Najděte šablonu, která vyhovuje vašim potřebám. Panel můžete po zavření opět otevřít pomocí nabídky Další akce (•••). </p>",
  "fabric.help.center.templates.title": "Šablony",
  "fabric.help.center.title": "Naučte se základy",
  "fabric.insert.external.image": "Vložit obrázek z webu",
  "fabric.template.can.not.parse.content": "Tuto šablonu se nepodařilo otevřít, protože obsahuje poškozené nebo nepodporované prvky.",
  "fabric.template.can.not.save.error.title": "Změny nelze uložit",
  "fabric.template.can.not.save.error.title.duplicate": " Šablona s názvem <strong>{0}</strong> už existuje. Pokud chcete šablonu uložit, vyberte jiný název.",
  "fabric.template.found.invalid.node": "Více proměnných šablon, které mají stejný název \"{variableNames}\", ale jiné parametry.",
  "favourite.spaces": "Moje prostory",
  "feedback.flag.thanks.description": "Vaše odpovědi nám pomohou vytvořit lepší uživatelské prostředí.",
  "feedback.flag.thanks.title": "Děkujeme!",
  "filter.name": "Filtrovat",
  "gif.file": "Soubor GIF",
  "global.spaces": "Prostory stránky",
  "globaladminbilling.label": "Fakturace",
  "header.or.footer.unsupported.macros.list": "Následující makra nejsou momentálně podporována v {0}:",
  "header.or.footer.unsupported.macros.title": "Nepodporovaná makra",
  "heading.comment": "Změnil",
  "heading.createpage": "Vytvořit stránku",
  "heading.createpage.sentence": "Vytvořit stránku",
  "heading.operations": "Operace",
  "heading.version.date": "Publikováno",
  "heading.version.number": "Verze",
  "help.name": "Nápověda",
  "help.us.improve": "Pomozte nám se zlepšováním",
  "hipchat.presence.status.available": "Dostupný",
  "hipchat.presence.status.away": "Pryč",
  "hipchat.presence.status.dnd": "Nerušit",
  "hipchat.presence.status.offline": "Offline",
  "html.file": "Soubor HTML",
  "icon.tooltip.remove": "Odstranit",
  "icon.tooltip.undo": "Zpět",
  "image.browser.imageurl.label": "Adresa URL obrázku",
  "image.height": "Výška",
  "image.properties.dialog.cancel": "Zrušit",
  "image.properties.dialog.heading": "Vlastnosti obrázku",
  "image.properties.trigger": "Vlastnosti",
  "image.properties.trigger.tooltip": "Nastavte další vlastnosti obrázku",
  "inline.comment.sidebar.navigate.next.description": "Další vložený komentář",
  "inline.comment.sidebar.navigate.previous.description": "Předchozí vložený komentář",
  "inline.comments.GROW-1507.dialog.close.label": "Zavřít",
  "inline.comments.GROW-1507.dialog.content": "Víte, co jsou vložené komentáře?<br>Můžete je používat k recenzím, a to tak, že je přidáte do určité části dokumentu.",
  "inline.comments.GROW-1507.dialog.header": "Vložené komentáře",
  "inline.comments.GROW-1507.dialog.ok.label": "Ano, rozumím",
  "inline.comments.GROW-1507.dialog.showme.label": "Ukázat",
  "inline.comments.GROW-1507.dialog.title": "TIP PRO KOMENTÁŘ",
  "inline.comments.batch.email.view": "Zobrazit komentář",
  "inline.comments.create.placeholder": "napsat komentář…",
  "inline.comments.create.reply.placeholder": "Odpovědět",
  "inline.comments.date.friendly.about.one.hour.ago": "Před 1 hodinou",
  "inline.comments.date.friendly.about.x.days.ago": "Před {0} dny",
  "inline.comments.date.friendly.about.x.hours.ago": "Před {0} hodinami",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "právě teď",
  "inline.comments.date.friendly.one.min.ago": "Před 1 minutou",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, one {před {0} minutou} few {před {0} minutami} many {před {0} minutami} other {před {0} minutami}}",
  "inline.comments.date.friendly.yesterday": "včera",
  "inline.comments.delete.confirmation.message": "Opravdu chcete komentář odstranit?",
  "inline.comments.delete.permission": "Nemáte oprávnění odstranit tento komentář.",
  "inline.comments.delete.reply.confirmation.message": "Opravdu chcete odstranit tuto odpověď?",
  "inline.comments.delete.with.reply": "Vlákna vložených komentářů s odpověďmi nelze odstranit.",
  "inline.comments.delete.with.reply.need.reload": "Tento komentář nemůžete odstranit, protože v tomto vlákně jsou nové odpovědi. Chcete-li je zobrazit, znovu je načtěte.",
  "inline.comments.edit.permission": "Nemáte oprávnění upravovat tento komentář.",
  "inline.comments.editor.lost": "Váš komentář bude ztracen.",
  "inline.comments.editor.timeout": "Editor se nenačetl správně. {0}Aktualizujte stránku{1} a zkuste to znovu.",
  "inline.comments.expand.replies": "{0} dalších odpovědí",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Váš komentář je prázdný. Přidejte zpětnou vazbu a klikněte na tlačítko Uložit.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Kontrola Captcha byla neúspěšná",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Kontrola Captcha byla úspěšná",
  "inline.comments.fabric.editor.error.create.not.permitted": "Nastavení vašich oprávnění vám neumožňují vytvářet komentáře. Pokud tuto možnost potřebujete, obraťte se na administrátora.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Nastavení vašich oprávnění vám neumožňují odstraňovat komentáře. Pokud tuto možnost potřebujete, obraťte se na administrátora.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Nastavení vašich oprávnění vám neumožňují upravovat komentáře. Pokud tuto možnost potřebujete, obraťte se na administrátora.",
  "inline.comments.fabric.editor.error.invalid.selection": "Komentář se nepodařilo vytvořit. K tomu, aby se váš komentář namapoval na správný obsah, potřebujete jasně odlišený výběr. Zvýrazněte unikátnější text.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Nastavení vašich oprávnění vám neumožňují řešit komentáře. Pokud tuto možnost potřebujete, obraťte se na administrátora.",
  "inline.comments.fabric.editor.error.unexpected": "Při ukládání tohoto komentáře došlo k chybě. Zavřete komentář nebo obnovte stránku a zkuste komentář přidat znovu.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Nastavení vašich oprávnění vám neumožňují zobrazit komentář. Pokud tuto možnost potřebujete, obraťte se na administrátora.",
  "inline.comments.fabric.inline.button.cancel": "Zrušit",
  "inline.comments.fabric.inline.button.save": "Uložit",
  "inline.comments.fabric.sidebar.loading.error": "Došlo k chybě. Zavřete okno komentáře a zkuste to znovu",
  "inline.comments.likes.error": "Lajky nelze aktualizovat.",
  "inline.comments.likes.like": "To se mi líbí",
  "inline.comments.likes.unlike": "To se mi nelíbí",
  "inline.comments.navigation.index.of": "{0} z {1}",
  "inline.comments.notification.email.reopened": "Znovu otevřeno",
  "inline.comments.notification.email.resolved": "Vyřešeno",
  "inline.comments.notification.email.view": "Zobrazit komentář",
  "inline.comments.resolve.permission": "Nemáte oprávnění řešit tento komentář.",
  "inline.comments.resolved.dangling.message": "Vyřešeno, protože text odstranil {0} {1}",
  "inline.comments.resolved.dialog.empty": "Na této stránce nejsou žádné vyřešené komentáře.",
  "inline.comments.resolved.dialog.message": "Tento komentář nezmizel navždy! Vyřešené komentáře můžete zobrazit kdykoli.",
  "inline.comments.resolved.dialog.show.me": "Ukázat",
  "inline.comments.resolved.discovery.button.dismiss": "Ano, rozumím",
  "inline.comments.resolved.discovery.content": "Chcete ještě něco sdělit? Chcete-li pokračovat v diskusi, můžete znovu otevřít vyřešené komentáře.",
  "inline.comments.resolved.menu.show.replies": "{0} odpovědí",
  "inline.comments.resolved.menu.show.reply": "{0} odpověď",
  "inline.comments.resolved.menu.unresolve": "Znovu otevřít",
  "inline.comments.resolved.message": "Vyřešil {0} {1}",
  "inline.comments.resolved.view.menu": "Vyřešené komentáře",
  "inline.comments.server.edit.error": "Nemůžeme uložit vaši úpravu. Komentář mohl být odstraněn.",
  "inline.comments.server.error": "Vaše žádost nemohla být dokončena.",
  "inline.comments.server.error.edit.comment": "Tento komentář nemůžeme upravit. Komentář mohl být odstraněn.",
  "inline.comments.server.error.edit.reply": "Tuto odpověď nemůžeme upravit. Odpověď mohla být odstraněna.",
  "inline.comments.sidebar.cancel": "Zrušit",
  "inline.comments.sidebar.close": "Zavřít",
  "inline.comments.sidebar.comment.empty": "Prázdný komentář nelze uložit.",
  "inline.comments.sidebar.delete": "Odstranit",
  "inline.comments.sidebar.deleted": "Odstraněno",
  "inline.comments.sidebar.discard": "Vyřadit",
  "inline.comments.sidebar.edit": "Upravit",
  "inline.comments.sidebar.error.create.comment": "Váš vložený komentář nemůžeme přidat. Zvýrazněná část může obsahovat makro nebo zmínku o uživateli. Zkuste zvýraznit prostý text.",
  "inline.comments.sidebar.error.delete.generic": "Chyba při odstraňování komentáře. Zkontrolujte, zda se v protokolech aplikace Confluence nevyskytují chyby.",
  "inline.comments.sidebar.error.delete.unauthorised": "Nemáte dostatečná oprávnění k odstranění tohoto komentáře.",
  "inline.comments.sidebar.error.empty": "Zadejte svůj komentář.",
  "inline.comments.sidebar.error.save.comment": "Komentář nebylo možné uložit",
  "inline.comments.sidebar.error.save.reply": "Odpověď nebylo možné uložit",
  "inline.comments.sidebar.error.stale": "Obsah stránky je neaktuální. {0}Obnovte{1} stránku a zkuste to znovu.",
  "inline.comments.sidebar.like": "To se mi líbí",
  "inline.comments.sidebar.pagecomment.success": "Komentář ke stránce byl úspěšně vytvořen",
  "inline.comments.sidebar.reply": "Odpovědět",
  "inline.comments.sidebar.resolve": "Vyřešit",
  "inline.comments.sidebar.resolved": "Vyřešeno",
  "inline.comments.sidebar.save": "Uložit",
  "inline.comments.sidebar.saved": "Uloženo",
  "inline.comments.sidebar.shortcuts.close.description": "Zavření vloženého komentáře",
  "inline.comments.sidebar.show.resolved.comment": "Zobrazit vyřešené komentáře",
  "inline.comments.sidebar.tooltip.close.description": "Zavřít postranní panel (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Další komentář (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Předchozí komentář (P)",
  "inline.comments.templates.create.a.comment": "<strong>okomentoval</strong> stránku",
  "inline.comments.templates.resolved.a.comment": "<strong>vyřešil</strong> komentář",
  "inline.comments.templates.resolved.a.comment.dangling": "odstraněný text, na který odkazuje vložený komentář, takže tento komentář byl <strong>vyřešen</strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>znovu otevřel</strong> komentář",
  "inline.comments.unresolved.message": "Znovu otevřel {0} {1}",
  "jar.file": "Archiv Java",
  "java.file": "Zdroj Java",
  "jpeg.file": "Soubor JPEG",
  "js.file": "Soubor JavaScript",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Option",
  "keyboard.shortcut.shift": "Shift",
  "label.contains.invalid.chars": "<b>{0}</b> obsahuje neplatné znaky ({1}).",
  "label.name.is.too.long": "Názvy štítků musí být menší než {0} znaků.",
  "labels.dialog.shortcut.tip": "Tip na zkratku: V zobrazení stránky se stisknutím tlačítka <b>{shortcut}</b> také otevřete dialogové okno",
  "labels.none": "Žádné štítky",
  "labels.title": "Štítky",
  "last.saved": "Naposledy uloženo",
  "likes.bethefirst": "Buďte první, komu se to líbí",
  "likes.follow": "Sledovat",
  "likes.following": "Sledující",
  "likes.like": "To se mi líbí",
  "likes.peoplewholikethis": "Lidé, kterým se to líbí",
  "likes.summary.1.non-promoted": "{0} se to líbí",
  "likes.summary.1.promoted": "{0} se to líbí",
  "likes.summary.1.promoted.1.non-promoted": "{0} a {1} se to líbí",
  "likes.summary.2.promoted": "{0} a {1} se to líbí",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1} a {2} se to líbí",
  "likes.summary.3.promoted": "{0}, {1} a {2} se to líbí",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2} a {3} se to líbí",
  "likes.summary.you": "Toto se vám líbí",
  "likes.summary.you.1.non-promoted": "Vám a {0} se to líbí",
  "likes.summary.you.1.promoted": "Vám a {0} se to líbí",
  "likes.summary.you.1.promoted.1.non-promoted": "Vám, {0} a {1} se to líbí",
  "likes.summary.you.2.promoted": "Vám, {0} a {1} se to líbí",
  "likes.summary.you.2.promoted.1.non-promoted": "Vám, {0}, {1} a {2} se to líbí",
  "likes.summary.you.3.promoted": "Vám, {0}, {1} a {2} se to líbí",
  "likes.summary.you.3.promoted.1.non-promoted": "Vám, {0}, {1}, {2} a {3} se to líbí",
  "likes.unlike": "Nelíbí se mi",
  "limited.mode.existing.editor.body": "Kolaborativní editace je momentálně offline a {0} upravuje tuto stránku. Zkuste to znovu za pár minut.",
  "link.browser.advanced.desc1": "Chcete-li vložit odkaz na novou stránku, zadejte název požadované stránky.",
  "link.browser.advanced.desc2": "Chcete-li vložit ukotvení, zadejte #názevukotvení.",
  "link.browser.advanced.error.internal.error": "Vyskytla se vnitřní chyba",
  "link.browser.advanced.error.not.link": "Uvedená značka není platná značka odkazu",
  "link.browser.advanced.error.unknown.shortcut": "{0} není uznaná zkratka",
  "link.browser.advanced.error.unknown.space": "{0} není rozpoznáno jako prostor",
  "link.browser.advanced.title": "Zde můžete do stránky vložit odkaz pomocí <a href=\"{0}\" target=\"_blank\">wiki značek</a>.",
  "link.browser.autocomplete.hint": "Tip: Zadejte v editoru „[\" pro zobrazení seznamu doporučených stránek a vložte odkaz.",
  "link.browser.cancel.button": "Zrušit",
  "link.browser.edit.button": "Vložit",
  "link.browser.edit.title": "Upravit odkaz",
  "link.browser.file.attach": "Nahrát soubor",
  "link.browser.file.attach.desc": "Vložte odkaz na soubor, který je připojen k této stránce, nebo připojte nový.",
  "link.browser.file.attach.upload.in.progress": "Nahrát v průběhu...",
  "link.browser.file.browse.button": "Prohlížejte",
  "link.browser.files.none": "Na této stránce nejsou žádné soubory.",
  "link.browser.insert.button": "Vložit",
  "link.browser.insert.title": "Vložte odkaz",
  "link.browser.link": "Odkaz",
  "link.browser.link.alias": "Text odkazu",
  "link.browser.link.image.label": "Propojit obrázek",
  "link.browser.location": "Umístění odkazu",
  "link.browser.recently.viewed.load.error": "Při načítání nedávno zobrazených stránek došlo k chybě",
  "link.browser.recently.viewed.none": "Nemáte žádný nedávno prohlížený obsah.",
  "link.browser.search": "Vyhledat",
  "link.browser.search.for": "Hledat",
  "link.browser.search.invalid": "Neplatné vyhledávací dotazy",
  "link.browser.search.results.load.error": "Během vyhledávání došlo k chybě",
  "link.browser.search.results.none": "Nebyly nalezeny žádné výsledky vyhledávání.",
  "link.browser.space.all": "Veškerý obsah",
  "link.browser.tab.name.advanced": "Rozšířené",
  "link.browser.tab.name.files": "Soubory",
  "link.browser.tab.name.recently.viewed": "Nedávno zobrazené",
  "link.browser.tab.name.search": "Vyhledat",
  "link.browser.tab.name.weblinks": "Internetový odkaz",
  "link.browser.table.file.comment": "Komentář",
  "link.browser.table.file.name": "Jméno",
  "link.browser.table.file.size": "Velikost",
  "link.browser.table.last.modified": "Naposledy upraveno",
  "link.browser.table.space": "Prostor",
  "link.browser.table.title": "Nadpis",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Web, e-mail nebo jiná internetová adresa",
  "link.browser.web.link.label": "Adresa",
  "location.name": "Umístění",
  "login.button": "Přihlásit se",
  "look.and.feel": "Vzhled a chování",
  "marketplace.link.name": "Aplikace Marketplace",
  "more.word.action": "Více akcí",
  "more.word.capitalised": "Více",
  "moveblogpost.already.exists.in.target.space": "Ve zvoleném prostoru již existuje jiný příspěvek na blogu se stejným názvem a datem.",
  "moveblogpost.source.notfound": "Zdrojový příspěvek na blogu nebyl nalezen.",
  "moveblogpost.target.space.notfound": "Cílový prostor nebyl nalezen.",
  "moveblogpost.target.space.same.as.origin": "Nemůžete přesunout příspěvek na blogu do prostoru, ve kterém je již vložen.",
  "multimedia.file": "Multimediální soubor",
  "my.drafts.mainBanner": "Poznamenejte si nápady snadno a rychle",
  "my.drafts.subBanner": "Vytvořte si stránku a poznamenejte si své nápady. Pokud ještě nejste připraveni je zveřejnit, stránku zavřete. Automaticky je uložíme jako koncept, abyste se k nim mohli vrátit, až připraveni budete. ",
  "my.spaces.tooltip.add": "Přidat do Mých prostor",
  "my.spaces.tooltip.remove": "Odebrat z Mých prostor",
  "name.word": "Jméno",
  "nav.controller.activity": "Aktivita",
  "nav.controller.activity.feed": "Přehled aktivit",
  "nav.controller.all.spaces": "Prostory",
  "nav.controller.discover": "Objevujte",
  "nav.controller.my.spaces": "Moje prostory",
  "nav.controller.my.spaces.anchor": "Vše",
  "nav.controller.my.spaces.blank": "Mějte své nejužitečnější prostory po ruce. Klepněte na ikonu hvězdičky vedle libovolného prostoru, aby se zobrazil zde.",
  "nav.controller.my.spaces.blank.callToAction": "Najít prostory",
  "nav.controller.projects": "Projekty",
  "nav.controller.recent": "Nedávné stránky",
  "nav.controller.your.work": "Vaše práce",
  "navigation.app.switcher.apps": "Aplikace",
  "navigation.app.switcher.dont.show.again": "Znovu nezobrazovat",
  "navigation.app.switcher.edit": "Upravit",
  "navigation.app.switcher.error-message": "Chyba při získávání odkazů na aplikace.",
  "navigation.app.switcher.home.description": "Domů",
  "navigation.app.switcher.img.alt": "Přepínač aplikací",
  "navigation.app.switcher.loading": "Nahrávání…",
  "navigation.app.switcher.recent": "Nedávné",
  "navigation.app.switcher.recent-containers-confluence-space": "Prostor",
  "navigation.app.switcher.recent-containers-jira-project": "Projekt",
  "navigation.app.switcher.try.other.apps": "Vyzkoušejte jiné aplikace",
  "navigation.app.switcher.use.confluence": "Použijte Confluence",
  "navigation.app.switcher.use.jira": "Použijte Jira",
  "navigation.label-for-bell": "Oznámení",
  "navigation.label-for-global-people-icon": "Adresář Lidé",
  "navigation.notification-drawer-title": "Oznámení Home",
  "navigation.people-drawer-title": "Adresář Lidé",
  "navlink.edit": "{0}E{1}ditovat",
  "network.page": "Stránka sítě",
  "no.drafts.found": "Nebyly nalezeny žádné návrhy.",
  "no.matches.mainBanner": "Nepodařilo se nám najít výsledky pro dotaz",
  "no.name": "Ne",
  "no.permission": "Bez povolení",
  "no.spaces.found": "Žádné prostory nebyly nalezeny.",
  "not.watching.anything": "Nyní nic nesledujete.",
  "notification.start": "Začít sledovat",
  "notification.stop": "Ukončit sledování",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#Vložený komentář|1<Vložené komentáře}",
  "notifications.batch.inline.comment.new.lozenge": "nový",
  "notifications.batch.inline.comment.reopened.lozenge": "znovu otevřel",
  "notifications.batch.inline.comment.resolved": "Uživatel $user $lozenge komentář",
  "notifications.batch.inline.comment.resolved.lozenge": "vyřešil",
  "notifications.preferences.desc": "Možnosti e-mailových oznámení můžete nastavit na stránce <a href=\"viewmyemailsettings.action\">nastavení e-mailu</a>.",
  "onboarding-choose-a-space.description": "Vyberte si ze současných prostorů vašeho týmu. Později budete moci vytvořit více prostorů.",
  "onboarding-choose-a-space.title": "Vyberte prostor, ve kterém budete pracovat",
  "onboarding.choose-a-space.backBtn": "Zpět",
  "onboarding.choose-a-space.nextBtn": "Další",
  "onboarding.choose-a-space.selectLabel": "Název prostoru",
  "onboarding.choose-a-space.selectPlaceholder": "Vyberte název prostoru",
  "onboarding.create-a-space.backBtn": "Zpět",
  "onboarding.create-a-space.description": "Začněte s prostorem pro svůj současný tým nebo projekt. Později budete moci vytvářet více prostorů.",
  "onboarding.create-a-space.inputTextLabel": "Název",
  "onboarding.create-a-space.inputTextPlaceholder": "Crystal gems",
  "onboarding.create-a-space.invalidMessage": "Název prostoru musí obsahovat alespoň dvě písmena nebo číslice.",
  "onboarding.create-a-space.nextBtn": "Další",
  "onboarding.create-a-space.title": "Vytvořte prostor, ve kterém budete pracovat",
  "onboarding.dialog.existing-user.cancel": "Nezobrazovat tipy",
  "onboarding.dialog.existing-user.confirm": "Pojďme na to",
  "onboarding.dialog.existing-user.content": "Přesunuli jsme pár věcí, abychom vám poskytli lepší zážitek s dashboardem, a navíc jsme vám aktivovali několik tipů, které vám pomohou začít.",
  "onboarding.dialog.existing-user.title": "Vítáme vás na vašem novém dashboardu!",
  "onboarding.dialog.new-user.cancel": "Nezobrazovat tipy",
  "onboarding.dialog.new-user.confirm": "Pojďme na to",
  "onboarding.dialog.new-user.content": "Dashboard je vstupní stránka, která vám pomůže se zorientovat v softwaru Confluence.<br/>Ukážeme vám několik tipů, abyste mohli začít.",
  "onboarding.dialog.new-user.title": "Vítejte na dashboardu!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Stiskněte tlačítko domů a přejděte na seznam stránek nebo jiný obsah.",
  "onboarding.navigation.blog.tip.blog.list.heading": "Seznam vašich blogů je stále k dispozici zde",
  "onboarding.navigation.dont.show": "Nezobrazovat další tipy",
  "onboarding.navigation.global.sidebar.byline": "Takže bez ohledu na to, kde se v Confluence nacházíte, k důležitým položkám se dostanete pouhým jedním kliknutím.",
  "onboarding.navigation.global.sidebar.heading": "Tento postranní panel je nyní univerzální",
  "onboarding.navigation.ok": "OK, rozumím",
  "onboarding.navigation.page.tip.page.tree.byline": "Stiskněte tlačítko domů a přejděte na seznam blogů nebo jiný obsah.",
  "onboarding.navigation.page.tip.page.tree.heading": "Váš strom stránek je stále k dispozici zde",
  "onboarding.navigation.space.tip.space.tabs.byline": "Domovská stránka vašeho prostoru je nyní přehledem a vaše stránky, příspěvky na blogy a další obsahy mají svoji vlastní kartu.",
  "onboarding.navigation.space.tip.space.tabs.heading": "Váš obsah je nyní organizován v kartách",
  "onboarding.tooltip.actions.done": "Rozumím!",
  "onboarding.tooltip.actions.next": "Další",
  "onboarding.tooltip.actions.skip": "Přeskočit tipy",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Přejděte přímo do svých oblíbených prostorů nebo navštivte seznam všech prostorů.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Vaše oblíbené prostory na dosah ruky",
  "onboarding.tooltip.existing-user.sidebar.content": "Najděte nové stránky a vraťte se ke své nedávné práci ze svého šikovného nového  postranního panelu.",
  "onboarding.tooltip.existing-user.sidebar.title": "Objevte více díky postrannímu panelu",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Můžete přejít přímo k oblíbeným prostorům nebo navštívit seznam všech prostorů.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Oblíbené prostory na dosah ruky",
  "onboarding.tooltip.new-user.sidebar.content": "Najděte nové stránky a vraťte se ke své nedávné práci z postranního panelu.",
  "onboarding.tooltip.new-user.sidebar.title": "Objevte více díky postrannímu panelu",
  "onboarding.tooltip.saved-for-later.content": "Vaše oblíbené stránky se nyní objeví pod novým názvem – Uloženo na později.",
  "onboarding.tooltip.saved-for-later.title": "Sbohem Oblíbené, ahoj Uloženo na později",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ přidat více e-mailů",
  "onboarding.who-is-on-your-team.description": "Confluence je lepší, když s vámi členové týmu tvoří, diskutují a spolupracují na vašem úkolu.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Přidat e-mailovou adresu",
  "onboarding.who-is-on-your-team.enableDRS": "Umožněte komukoli s ověřenou e-mailovou adresou domény {domain} připojení k vašemu webu (vždy vás o takové situaci budeme informovat).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Dovolte uživatelům, aby pozvali další lidi na vaši stránku.",
  "onboarding.who-is-on-your-team.form.invalid.email": "Zadejte platný e-mail, prosím.",
  "onboarding.who-is-on-your-team.nextBtn": "Další",
  "onboarding.who-is-on-your-team.title": "Kdo je ve vašem týmu?",
  "only.personal.labels.permitted": "Na tuto stránku je povoleno přidávat pouze osobní štítky.",
  "org.randombits.confluence.toc.toc.label": "Obsah",
  "page.already.exists": "Ve zvoleném prostoru již existuje jiná stránka se stejným názvem.",
  "page.already.exists.inspace": "Stránka '{'0'}' už v prostoru '{'1'}' existuje. Před přesunutím stránky musíte změnit její název.",
  "page.change": "Co jste změnili?",
  "page.comments.saved.dialog.message": "Váš komentář byl uložen jako komentář k stránce.",
  "page.comments.sidebar.warning": "K tomuto obsahu nemůžeme přidat vložený komentář. Místo toho jej přidáme jako komentář k stránce.",
  "page.descendent.already.exists": "Vedlejší stránka sdílí stejný název jiné stránky ve vybraném prostoru.",
  "page.permissions.menu.item.title": "Omezení",
  "page.permissions.menu.item.title.tooltip": "Upravit omezení",
  "page.tree.blankExperience.mainBanner": "Není tu nic jiného než potenciál.",
  "page.tree.blankExperience.subBanner": "Začněte vytvářet poznámky ze schůzek, požadavky na produkt, články typu „jak na to“ nebo jiný obsah a zaplňte tak tento prostor.",
  "page.watch.instruction": "Chcete-li sledovat stránku nebo příspěvek na blogu: otevřete nabídku Nástroje a klikněte na položku Sledovat.",
  "page.watches": "Sledování stránky",
  "page.word": "Stránka",
  "pages.navigation.discovery.body.html": "Kliknutím na <strong>Stránky</strong> zobrazíte strom stránek, což je prostor, ve kterém můžete prohlížet všechny stránky.",
  "pages.navigation.discovery.header": "Strom stránek nyní žije zde",
  "pages.show.all": "Zobrazit všechny stránky",
  "pages.word": "Stránky",
  "pagetree.dragndrop.failed.action.visitsupport": "Navštivte podporu Atlassian",
  "pagetree.dragndrop.failed.description": "Aktualizujte stránku a zkuste to znovu. Pokud se to bude znovu opakovat, dejte nám vědět pomocí níže uvedeného odkazu.",
  "pagetree.dragndrop.failed.title": "Někde se stala chyba",
  "pagetree.failed.load.content": "Nepodařilo se načíst strom stránek",
  "pagetree.failed.load.tooltip": "Vydržte, pracujeme na tom, abychom to opravili.",
  "parent.page.invalid.for.space": "V prostoru <b>{1}</b> není žádná stránka s názvem <b>{0}</b>.",
  "parent.page.name": "Nadřazená stránka",
  "pdf.file": "Soubor PDF",
  "people.directory.name": "Lidé",
  "period.lastSevenDays": "Za poslední týden",
  "period.lastThirtyDays": "V posledním měsíci",
  "period.older": "Více než před měsícem",
  "period.today": "Dnes",
  "period.yesterday": "Včera",
  "permission.owner.not.in.group": "Oprávnění k přístupu ke stránkám můžete udělit pouze skupinám, kterých jste členem",
  "permission.owner.not.set": "Musíte vybrat majitele povolení",
  "permissions.comment": "Definujte, kdo může zobrazit a upravit stránku. Tato oprávnění můžete omezit na sebe nebo na skupinu uživatelů.",
  "permissions.edit.title": "Upravit",
  "permissions.select.nopermissions": "Není nastaveno",
  "permissions.view.title": "Zobrazit",
  "person.follow": "Sledovat",
  "person.follow.stop": "Zastavit sledování",
  "personal.spaces": "Osobní prostory",
  "placeholder.placeholdertext.label": "Text placeholderu",
  "placeholder.replacementtext.label": "Text nahrazení",
  "please.enter.a.label": "Zadejte prosím štítek.",
  "png.file": "Soubor PNG",
  "popular.stream.mainBanner": "Neděje se nic zajímavého... Zatím",
  "popular.stream.subBanner": "Věci jsou teď docela tiché, ale jakmile váš tým začne s tvorbou, objeví se zde nejoblíbenější stránky a soubory.",
  "popular.stream.subBanner2": "Pojďme tuhle párty odstartovat!",
  "popular.stream.title": "Oblíbené",
  "posted.word": "Zveřejněno",
  "powerpoint.file": "Prezentace aplikace Microsoft Powerpoint",
  "powerpoint.macro.file": "Prezentace Microsoft PowerPoint s povolenými makry",
  "powerpoint.slideshow.file": "Prezentace Microsoft PowerPoint",
  "powerpoint.template.file": "Šablona Microsoft Powerpoint",
  "powerpoint97.file": "Prezentace Microsoft PowerPoint 97",
  "powerpoint97.template.file": "Šablona Microsoft Powerpoint 97",
  "product.name": "Confluence",
  "profile.page": "Profilová stránka",
  "property.panel.macro.display.inline": "Zobrazit v řádku",
  "property.panel.macro.display.newline": "Zobrazit na novém řádku",
  "property.panel.macro.edit": "Upravit",
  "property.panel.macro.remove": "Odstranit",
  "property.panel.textplaceholder.display.default": "Text",
  "property.panel.textplaceholder.display.default.tooltip": "Když daná osoba píše, instruktážní text je nahrazen prázdným obsahem.",
  "property.panel.textplaceholder.display.mention": "Uživatel zmínil",
  "property.panel.textplaceholder.display.mention.tooltip": "Když daná osoba píše, instruktážní text je nahrazen navrhovanými lidmi.",
  "property.panel.textplaceholder.remove": "Odstranit",
  "property.panel.variable.display.list": "Seznam",
  "property.panel.variable.display.list.tooltip": "Rozevírací seznam.",
  "property.panel.variable.display.string": "Text",
  "property.panel.variable.display.string.tooltip": "Pole pro zadání jednořádkového textu.",
  "property.panel.variable.display.textarea": "Víceřádkový text",
  "property.panel.variable.display.textarea.tooltip": "Pole pro zadání víceřádkového textu.",
  "property.panel.variable.list.values.tooltip": "Zadejte jednotlivé položky seznamu oddělené čárkou.",
  "property.panel.variable.textarea.columns.tooltip": "Počet sloupců, které se mají zobrazit pro dané pole.",
  "property.panel.variable.textarea.rows.tooltip": "Počet řádků, které se mají zobrazit pro dané pole.",
  "quick.comment.placeholder.message": "Napište komentář",
  "quick.reload.edit": "Nové úpravy stránek",
  "quick.reload.edit.by": "od",
  "quick.reload.edit.more": "a {0} dalších",
  "quick.reload.edit.one.more": "a 1 další",
  "quick.reload.edits": "{0} nové úpravy",
  "quick.reload.newcomments": "{0} nových komentářů",
  "quick.reload.newpagecomment": "Nový komentář",
  "quick.reload.reload": "Znovu načíst stránku",
  "recently-updated-content-list.commented.new": "Okomentováno {time}",
  "recently-updated-content-list.created.new": "Vytvořeno {time}",
  "recently-updated-content-list.edited.new": "Aktualizováno {time}",
  "recently.viewed.mainBanner": "Čas vytvořit historii",
  "recently.viewed.subBanner": "Zatím jste ještě nenavštívili žádné stránky, ale když to uděláte, výsledek umístíme sem, abyste se k nim mohli rychle vrátit.",
  "recently.viewed.subBanner2": "Nyní přejděte do <b>prostoru</b> a prohlédněte si jej.",
  "recently.viewed.title": "Nedávno navštívené",
  "recently.worked.mainBanner": "Dokončete to mistrovské dílo",
  "recently.worked.subBanner": "Zatím jste ještě nic nevytvořili ani neupravili, ale když to uděláte, výsledek umístíme sem, abyste mohli snadno navázat tam, kde jste skončili.",
  "recently.worked.subBanner2": "Nyní vytvořte svou nejlepší práci.",
  "recently.worked.title": "Nedávno proběhla práce",
  "remove.comment.confirmation.message": "Opravdu si přejete odstranit tento komentář?",
  "remove.label": "Odstranit štítek",
  "resize.image.dialog.title": "Změnit velikost obrázku",
  "restore.this.version": "Obnovit",
  "result.grid.column.content.last.modified": "Naposledy upraveno",
  "resume.editing": "Pokračovat",
  "return.to.page.info": "Vraťte se na Informace o stránce",
  "satisfaction.survey.reaction.amazing": "Úžasné",
  "satisfaction.survey.reaction.bad": "Špatné",
  "satisfaction.survey.reaction.great": "Skvělé",
  "satisfaction.survey.reaction.okay": "OK",
  "satisfaction.survey.reaction.terrible": "Příšerné",
  "save.name": "Uložit",
  "scheme.desc.custom": "Vlastní barevné schéma, které lze upravovat.",
  "scheme.desc.global": "Toto barevné schéma bude používat globálně definované barevné schéma pro tento prostor.",
  "scheme.title.custom": "Vlastní barevné schéma",
  "scheme.title.global": "Globální barevné schéma",
  "search.drawer.recently.viewed": "Nedávno zobrazené",
  "search.drawer.recently.viewed.spaces": "Nedávné prostory",
  "search.name": "Vyhledat",
  "settings.name": "Nastavení",
  "share.button.restriction.message.text": "Omezení na této stránce mohou lidem zabránit v prohlížení nebo úpravách",
  "share.button.text": "Sdílet",
  "show.more.blogposts": "Zobrazit více příspěvků na blogu",
  "sidebar.avatar.picker.upload.error": "Při aktualizaci detailů prostoru došlo k chybě",
  "sidebar.main.back.to.overview": "Zpět na přehled",
  "sidebar.main.back.to.space": "Zpět na prostor",
  "sidebar.main.blog": "Blog",
  "sidebar.main.quick.links": "Zkratky prostoru",
  "sidebar.main.settings": "Nastavení prostoru",
  "sidebar.main.shortcuts": "Propojení",
  "sidebar.main.wiki": "Stránky",
  "site-settings.templates-and-blueprints.edit-button-label": "Upravit",
  "space.404.banner.title": "Jejda, našli jste nefunkční odkaz",
  "space.404.go.back": "Vraťte se zpět na",
  "space.404.go.to": "Přejít na",
  "space.404.home.page": "domácí stránka",
  "space.404.previous.page": "předchozí stránka",
  "space.create": "Vytvořte prostor",
  "space.home.blog.blankExperience.mainBanner": "Chcete něco sdílet?",
  "space.home.blog.blankExperience.subBanner": "Příspěvky na blogu jsou skvělým způsobem, jak sdílet oznámení, zprávy o stavu nebo další důležité zprávy s vaším týmem.",
  "space.home.overview.blankExperience.mainBanner": "No, toto je trochu nepříjemné.",
  "space.home.overview.blankExperience.subBanner": "Tento prostor nemá domovskou stránku, takže zde není nic k zobrazení. Jsme také smutní.",
  "space.home.overview.blankExperience.subBanner2": "Nyní pro vylepšení přidejte domovskou stránku, abyste své návštěvníky informovali, na co je tento prostor zaměřen!",
  "space.not.exists": "Prostor, který jste zadali, neexistuje.",
  "space.personal.name": "Osobní prostor",
  "space.set.space.home": "Nastavte domovskou stránku prostoru",
  "space.watch.instruction": "Chcete-li sledovat stránky nebo příspěvky na blogu v prostorech, klikněte v bočním panelu prostoru na volbu „Stránky“ nebo „Blog“.",
  "space.watches": "Hodinky prostoru",
  "spaces.all": "Všechny prostory",
  "spaces.lookandfeel.help": "Zde si můžete přizpůsobit vzhled tohoto prostoru Confluence.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Upozornění:</span> <i>všechny zde provedené úpravy mají přednost před výchozím barevným schématem a výchozími dekoratéry nastaveným administrátorem.</i>",
  "spaces.word": "Prostory",
  "starred.mainBanner": "Není tu nic k vidění... Zatím",
  "starred.spaces.tooltip.add": "Označit tento prostor hvězdičkou",
  "starred.spaces.tooltip.remove": "Odebrat hvězdičku tomuto prostoru",
  "starred.subBanner": "Klepnutím na ikonu <b>hvězdičky</b> uložíte stránku na později. Umístíme ho sem, abyste jej mohli v případě potřeby nalézt.",
  "starred.title": "Uloženo na později",
  "status.lozenge.draft": "Koncept",
  "status.lozenge.unpublished": "Nepublikované změny",
  "submit.name": "Odeslat",
  "super-admin.banner.exit": "Přestat používat klíč administrátora",
  "super-admin.banner.message": "Používáte klíč správce, který vám umožňuje dočasný přístup k obsahu s omezením.",
  "switch.apps": "Přepnout aplikace",
  "system.help.legal": "Právo",
  "team.create.flag.error.description": "Nepodařilo se nám pro vás vytvořit tým. Zkuste to znovu za chvilku.",
  "team.create.flag.error.title": "Jejda! Něco se pokazilo.",
  "team.created.flag.description": "{membersCount, plural, one {Pozvali jste {membersCount} člověka do týmu '{'teamName'}'} few {Pozvali jste {membersCount} lidi do týmu '{'teamName'}'} many {Pozvali jste {membersCount} člověka do týmu '{'teamName'}'} other {Pozvali jste {membersCount} lidí do týmu '{'teamName'}'}}",
  "team.created.flag.title": "Byl vytvořen nový tým",
  "team.created.flag.view": "Zobrazit tým",
  "template.variables.fabric.section.message": "Tato šablona používá proměnné. Jakmile je vyplníte, informace, které poskytnete, se stanou součástí obsahu vaší nové stránky.",
  "templates.name": "Šablony",
  "text.file": "Textový soubor",
  "text.selected": "Vybráno",
  "tinymce.advanced.block": "Formát",
  "tinymce.advanced.blockquote": "Citace",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Tučné",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Seznam s odrážkami",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "Symbol",
  "tinymce.advanced.forecolor_desc": "Zvolte barvu textu",
  "tinymce.advanced.formatting_desc": "Formátovaní",
  "tinymce.advanced.h1": "Nadpis 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Nadpis 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Nadpis 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Nadpis 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Nadpis 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Nadpis 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "Nadpisy 1 až 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "Horizontální linka",
  "tinymce.advanced.indent_desc": "Zvětšit odsazení",
  "tinymce.advanced.italic_desc": "Kurzíva",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "Zarovnat na střed",
  "tinymce.advanced.justifyfull_desc": "Zarovnat úplně",
  "tinymce.advanced.justifyleft_desc": "Zarovnat vlevo",
  "tinymce.advanced.justifyright_desc": "Zarovnat vpravo",
  "tinymce.advanced.numlist_desc": "Číslovaný seznam",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Shift+N",
  "tinymce.advanced.outdent_desc": "Zmenšit odsazení",
  "tinymce.advanced.paragraph": "Odstavec",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "Předformátováno",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "Opakovat",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "Přeškrtnuté",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Shift+S",
  "tinymce.advanced.sub_desc": "Dolní index",
  "tinymce.advanced.sup_desc": "Horní index",
  "tinymce.advanced.tasklist_desc": "Seznam úloh",
  "tinymce.advanced.tasklist_shortcut": "[ poté ]",
  "tinymce.advanced.underline_desc": "Podtržený",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "Zpět",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "Zrušit propojení",
  "tinymce.atlassian.help": "Nápověda",
  "tinymce.atlassian.insert_menu": "Vložit",
  "tinymce.atlassian.insert_menu.charmap_desc": "Vložte symbol",
  "tinymce.atlassian.insert_menu.content_desc": "Vložte obsah",
  "tinymce.atlassian.insert_menu.hr_desc": "Vložit horizontální čáru (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Vložit makro",
  "tinymce.atlassian.insert_menu.tooltip": "Vložte další obsah",
  "tinymce.atlassian.monospace": "Neproporcionální",
  "tinymce.atlassian.monospace_desc": "Formátujte text pomocí neproporcionálního písma",
  "tinymce.atlassian.more_menu": "Více",
  "tinymce.atlassian.remove_formatting": "Vymazat formátování",
  "tinymce.atlassian.remove_formatting_desc": "Vymaže formátování aktuálně vybraného textu",
  "tinymce.auiwindowmanager.cancel": "Zrušit",
  "tinymce.auiwindowmanager.ok": "OK",
  "tinymce.autocomplete.web.resource.name": "Automatické doplňování webových zdrojů softwaru Confluence",
  "tinymce.autocomplete.web.resource.only.name": "Software Confluence automaticky doplňuje webové zdroje bez závislostí",
  "tinymce.charmap.web.resource.name": "Webové zdroje charakteru mapy TinyMce",
  "tinymce.charmap_dlg.title": "Vložte symbol",
  "tinymce.colorpicker.color": "Barva",
  "tinymce.colorpicker.more_colors": "Více barev",
  "tinymce.colorpicker.picker_tab": "Sběrač",
  "tinymce.colorpicker.picker_title": "Výběr barvy",
  "tinymce.colorpicker.title": "Vyberte barvu",
  "tinymce.colorpicker.web.resource.name": "Webové zdroje softwaru Confluence pro výběr barev",
  "tinymce.confluence.conf_emoji": "Emoji",
  "tinymce.confluence.conf_emoticon": "Emotikon",
  "tinymce.confluence.conf_emoticon_desc": "Vložte smajlík",
  "tinymce.confluence.conf_file": "Soubory a obrázky",
  "tinymce.confluence.conf_file_desc": "Vložte soubory a obrázky",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "Obrázek",
  "tinymce.confluence.conf_image_desc": "Vložit obrázek",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "Odkaz",
  "tinymce.confluence.conf_link_desc": "Vložte odkaz",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "Makro",
  "tinymce.confluence.conf_macro_browser_desc": "Vložit makro",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Shift+A",
  "tinymce.confluence.conf_media": "Obrázek/Média",
  "tinymce.confluence.conf_other_macros_desc": "Ostatní makra...",
  "tinymce.confluence.conf_shortcuts_help": "Klávesové zkratky – Nápověda",
  "tinymce.confluence.conf_tasklist": "Seznam úloh",
  "tinymce.confluence.conf_tasklist_desc": "Vložit seznam úkolů",
  "tinymce.confluence.conf_tasklist_shortcut": "[ poté ]",
  "tinymce.confluence.conf_widget_desc": "Widget",
  "tinymce.confluence.conf_wikimarkup": "Značka",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Vložit",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Chyby konverze wiki značek",
  "tinymce.confluence.conf_wikimarkup_desc": "Vložit značkovací jazyk",
  "tinymce.confluence.conf_wikimarkup_hint": "Tip: můžete také psát značkovacím jazykem přímo v editoru, kde bude formátován v průběhu vašeho psaní.",
  "tinymce.confluence.conf_wikimarkup_info_title": " Zadejte značky Confluence wiki nebo Markdown níže. Software Confluence převede obsah na formát editoru a vloží jej do vaší stránky.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Snížení",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Náhled",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Shift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "Serveru trvalo převedení značky wiki příliš dlouho. Může to být pouze dočasný problém, měli byste to tedy zkusit znovu.",
  "tinymce.confluence.files": "Soubory",
  "tinymce.confluence.help_desc": "Nápověda",
  "tinymce.confluence.htmlsource": "Zdroj",
  "tinymce.confluence.htmlsource_desc": "Zobrazit zdroj HTML",
  "tinymce.confluence.layout.menu": "Rozvržení stránky",
  "tinymce.confluence.layout.none": "Žádné rozložení",
  "tinymce.confluence.layout.three_col": "Tři sloupce",
  "tinymce.confluence.layout.three_col_sidebars": "Tři sloupce (levá a pravá postranní lišta)",
  "tinymce.confluence.layout.three_col_simple": "Tři sloupce (jednoduché)",
  "tinymce.confluence.layout.two_col": "Dva sloupce",
  "tinymce.confluence.layout.two_col_left": "Dva sloupce (levý postranní panel)",
  "tinymce.confluence.layout.two_col_right": "Dva sloupce (pravý postranní panel)",
  "tinymce.confluence.layout.two_col_simple": "Dva sloupce (jednoduché)",
  "tinymce.confluence.layout.two_col_simple_left": "Dva sloupce (jednoduché, levý postranní panel)",
  "tinymce.confluence.layout.two_col_simple_right": "Dva sloupce (jednoduchý, pravý postranní panel)",
  "tinymce.confluence.macro_insert": "Vložit makro '{'0'}'",
  "tinymce.confluence.macro_other": "Ostatní makra",
  "tinymce.confluence.macro_other_desc": "Otevřete prohlížeč maker",
  "tinymce.confluence.placeholder.inline.tasks": "Zadejte úkol zde pomocí „@“ pro přiřazení uživateli a „//“ pro zvolení konečného termínu",
  "tinymce.confluence.preview": "Náhled",
  "tinymce.confluence.preview_shortcut": "Ctrl+Shift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "Nastavení editoru",
  "tinymce.confluence_dlg.insertbutton.title": "Vložit",
  "tinymce.confluence_dlg.insertimage.title": "Vložit obrázek",
  "tinymce.confluence_dlg.insertlink.title": "Vložte odkaz",
  "tinymce.emotions.emotions_desc": "Emotikony",
  "tinymce.emotions.web.resource.name": "Webové zdroje emocí TinyMce",
  "tinymce.emotions_dlg.add": "Plus (+)",
  "tinymce.emotions_dlg.biggrin": "Velký úsměv :D",
  "tinymce.emotions_dlg.broken_heart": "Zlomené srdce </3",
  "tinymce.emotions_dlg.check": "Zaškrtněte (/)",
  "tinymce.emotions_dlg.desc": "Emotikony",
  "tinymce.emotions_dlg.error": "Chyba (x)",
  "tinymce.emotions_dlg.forbidden": "Mínus (-)",
  "tinymce.emotions_dlg.heart": "Srdce <3",
  "tinymce.emotions_dlg.help_16": "Otazník (?)",
  "tinymce.emotions_dlg.information": "Informace (i)",
  "tinymce.emotions_dlg.lightbulb": "Žárovka nesvítí (vypnuto)",
  "tinymce.emotions_dlg.lightbulb_on": "Žárovka je (zapnuta)",
  "tinymce.emotions_dlg.sad": "Smutek :(",
  "tinymce.emotions_dlg.smile": "Úsměv :)",
  "tinymce.emotions_dlg.star_blue": "Modrá hvězda (*b)",
  "tinymce.emotions_dlg.star_green": "Zelená hvězda (*g)",
  "tinymce.emotions_dlg.star_red": "Červená hvězdička (*r)",
  "tinymce.emotions_dlg.star_yellow": "Žlutá hvězdička (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Palec dolů (n)",
  "tinymce.emotions_dlg.thumbs_up": "Palec nahoru (y)",
  "tinymce.emotions_dlg.title": "Vložte smajlík",
  "tinymce.emotions_dlg.tongue": "Jazyk :p",
  "tinymce.emotions_dlg.warning": "Varování (!)",
  "tinymce.emotions_dlg.wink": "Mrknutí ;)",
  "tinymce.fabric.migration.dialog.action": "Pokračovat v editaci",
  "tinymce.fabric.migration.dialog.content": "Buďte bez obav, vaše změny nejsou ztraceny. Jen musíme vaši stránku aktualizovat.",
  "tinymce.fabric.migration.dialog.title": "Právě jsme aktualizovali vaše editační rozhraní",
  "tinymce.formatting.paragraph": "Normální text",
  "tinymce.full_screen.toolbar_item": "Celá obrazovka",
  "tinymce.full_screen.toolbar_item_title": "Spusťte editor na celou obrazovku",
  "tinymce.hints.autoformat.code": "Tip: Pokud chcete rychle vložit neproporcionální text, zadejte „<strong>'{{'code'}}'</strong>“.",
  "tinymce.hints.autoformat.heading1": "Tip: Zadejte „<strong>h1. Název</strong>“ pro rychlé vložení Nadpisu 1.",
  "tinymce.hints.autoformat.heading3": "Tip: Zadejte „<strong>h3. Název</strong>“ pro rychlé vložení Nadpisu 3.",
  "tinymce.hints.dnd": "Tip: můžete přetáhnout obrázky a soubory Office z počítače přímo do tohoto editoru.",
  "tinymce.hints.drafts": "Tip: Confluence automaticky ukládá koncept. Pokud někdy zavřete okno, můžete svoji práci obnovit výběrem „Uživatelské jméno -> Koncepty“.",
  "tinymce.hints.insert.bullet.list": "Tip: stisknutím <strong>Ctrl+Shift+B</strong> vytvoříte seznam s odrážkami.",
  "tinymce.hints.insert.heading": "Tip: stiskněte <strong>Ctrl+1</strong> pro vytvoření úrovně nadpisu 1, <strong>Ctrl+2</strong> pro úroveň úrovně 2 a tak dále.",
  "tinymce.hints.insert.image": "Tip: stisknutím <strong>Ctrl+M</strong> otevřete prohlížeč obrázků.",
  "tinymce.hints.insert.image.end": "Tip: stisknutím <strong>Ctrl+Shift+M</strong> po napsání slova najdete a vložíte příslušné obrázky.",
  "tinymce.hints.insert.image.on.page": "Tip: zadejte „<strong>!</strong>“ pro zobrazení obrázků připojených k stránce a vložení jednoho z nich.",
  "tinymce.hints.insert.image.search": "Tip: zadejte „<strong>!</strong>“ a část názvu obrázku pro nalezení a vložení obrázku.",
  "tinymce.hints.insert.link": "Tip: stisknutím <strong>Ctrl+K</strong> otevřete prohlížeč odkazů.",
  "tinymce.hints.insert.link.end": "Tip: Stiskněte <strong>Ctrl+Shift+K</strong> po napsání slova pro nalezení a propojení odkazů na příslušné stránky. Opět stiskněte pro další návrhy.",
  "tinymce.hints.insert.link.newpage": "Tip: zadejte „<strong>[</strong>“ a název nové stránky, kterou chcete vytvořit, pro zobrazení návrhu odkazu pro vložení.",
  "tinymce.hints.insert.link.recently.viewed": "Tip: Zadejte \"<strong>[</strong>\", chcete-li zobrazit seznam doporučených stránek a vložit odkaz.",
  "tinymce.hints.insert.link.search": "Tip: zadejte „<strong>[</strong>“ a část názvu hledané stránky a vytvořte tak odkaz na tuto stránku.",
  "tinymce.hints.insert.link.user.mention": "Tip: můžete někoho zmínit v prostoru Confluence zadáním „<strong>@</strong>“ a poté napište jeho jméno.",
  "tinymce.hints.insert.macro": "Tip: stisknutím <strong>Ctrl+Shift+A</strong> otevřete prohlížeč maker.",
  "tinymce.hints.insert.macro.toc": "Tip: Nechte software Confluence vygenerovat obsah této stránky. Použijte „Vložit -> Obsah“",
  "tinymce.hints.insert.newline": "Tip: Zadejte <strong>Shift+Enter</strong> pro vložení nového odstavce bez řádkování",
  "tinymce.hints.insert.numbered.list": "Tip: Stisknutím <strong>Ctrl+Shift+N</strong> vytvoříte číslovaný seznam.",
  "tinymce.hints.insert.table": "Tip: stisknutím <strong>Ctrl+Shift+I</strong> vložíte tabulku.",
  "tinymce.hints.insert.wikimarkup": "Tip: editor při psaní automaticky převede značku wiki",
  "tinymce.hints.insert.wikimarkup.dialog": "Tip: Stisknutím <strong>Ctrl+Shift+D</strong> otevřete dialog Wiki Markup.",
  "tinymce.hints.table.rows.copy": "Tip: stisknutím <strong>Ctrl+Shift+C</strong> zkopírujete řádek a <strong>Ctrl+Shift+V</strong> vložíte řádek do tabulky.",
  "tinymce.hints.table.rows.cut": "Tip: Stisknutím <strong>Ctrl+Shift+X</strong> vyjmete řádek a <strong>Ctrl+Shift+V</strong> vložíte řádek do tabulky.",
  "tinymce.macro.preview.exception": "Během prohlížení makra se vyskytla výjimka. Výjimka: {0}",
  "tinymce.macro.unknownMacro": "Makro '{'0'}' je neznámé. Mohlo být odebráno ze systému.",
  "tinymce.popup_blocked": "Prohlížeč zablokoval vyskakovací okno otevřené aplikací Editor.",
  "tinymce.propertypanel.images.border": "Rámeček",
  "tinymce.propertypanel.images.border.tooltip": "Zobrazit okraj okolo obrázku",
  "tinymce.propertypanel.images.large": "Velký",
  "tinymce.propertypanel.images.large.tooltip": "Změňte velikost obrázku na velký a připojte jej k originálu",
  "tinymce.propertypanel.images.link.create": "Odkaz",
  "tinymce.propertypanel.images.link.create.tooltip": "Tento obrázek propojte s jiným obsahem",
  "tinymce.propertypanel.images.link.edit": "Upravit odkaz",
  "tinymce.propertypanel.images.link.edit.tooltip": "Upravte odkaz pro tento obrázek",
  "tinymce.propertypanel.images.link.remove": "Zrušit propojení",
  "tinymce.propertypanel.images.link.remove.tooltip": "Odstraňte odkaz na tento obrázek",
  "tinymce.propertypanel.images.medium": "Střední",
  "tinymce.propertypanel.images.medium.tooltip": "Změňte velikost obrázku na střední a připojte jej k originálu",
  "tinymce.propertypanel.images.original": "Originál",
  "tinymce.propertypanel.images.original.tooltip": "Obnovte původní velikost obrázku",
  "tinymce.propertypanel.images.sizing.tooltip": "Změňte velikost obrázku na určitou šířku",
  "tinymce.propertypanel.images.small": "Malé",
  "tinymce.propertypanel.images.small.tooltip": "Změňte velikost obrázku na malý a připojte jej k originálu",
  "tinymce.propertypanel.links.edit": "Upravit",
  "tinymce.propertypanel.links.edit.tooltip": "Upravit odkaz v dialogovém okně",
  "tinymce.propertypanel.links.goto": "Přejít na odkaz",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "Tímto odkazem se dostanete na obsah stránky, kterou upravujete",
  "tinymce.propertypanel.links.unlink": "Zrušit propojení",
  "tinymce.propertypanel.links.unlink.tooltip": "Nahraďte odkaz textem, který obsahuje",
  "tinymce.searchreplace.replace_desc": "Najít/Nahradit",
  "tinymce.searchreplace.search_desc": "Najít",
  "tinymce.searchreplace_dlg.allreplaced.plural": "bylo provedeno {0} nahrazení",
  "tinymce.searchreplace_dlg.allreplaced.singular": "Byla provedena 1 výměna",
  "tinymce.searchreplace_dlg.close": "Zavřít",
  "tinymce.searchreplace_dlg.direction": "Směr",
  "tinymce.searchreplace_dlg.down": "Dolů",
  "tinymce.searchreplace_dlg.findlabel": "Najít",
  "tinymce.searchreplace_dlg.findnext": "Další",
  "tinymce.searchreplace_dlg.findprevious": "Předchozí",
  "tinymce.searchreplace_dlg.findwhat": "Najít co",
  "tinymce.searchreplace_dlg.mcase": "Rozlišovat malá a velká písmena",
  "tinymce.searchreplace_dlg.notfound": "Nebyly provedeny žádné výměny",
  "tinymce.searchreplace_dlg.replace": "Zaměnit",
  "tinymce.searchreplace_dlg.replace_title": "Najít/Nahradit",
  "tinymce.searchreplace_dlg.replaceall": "Nahradit vše",
  "tinymce.searchreplace_dlg.replacelabel": "Zaměnit",
  "tinymce.searchreplace_dlg.search_title": "Najít",
  "tinymce.searchreplace_dlg.searchnext_desc": "Najít znovu",
  "tinymce.searchreplace_dlg.up": "Nahoru",
  "tinymce.style.show-eol-markers": "Â¶",
  "tinymce.style.show-eol-markers.title": "Zobrazit/skrýt značky konce řádku",
  "tinymce.table": "Tabulka",
  "tinymce.table.cell": "Buňka",
  "tinymce.table.col": "Sloupec",
  "tinymce.table.col_after_desc": "Vložit sloupec za",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "Vložit sloupec před",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "Kopírovat sloupec tabulky",
  "tinymce.table.col_cut_desc": "Vystřihnout sloupec tabulky",
  "tinymce.table.col_highlight": "Kolonka nadpisu",
  "tinymce.table.col_paste_desc": "Vložte sloupec tabulky",
  "tinymce.table.copy_row_desc": "Kopírovat řádek tabulky",
  "tinymce.table.copy_row_shortcut": "Ctrl+Shift+C",
  "tinymce.table.cut_row_desc": "Vyjmout řádek tabulky",
  "tinymce.table.cut_row_shortcut": "Ctrl+Shift+X",
  "tinymce.table.del": "Odstranit tabulku",
  "tinymce.table.delete_col_desc": "Odstranit sloupec",
  "tinymce.table.delete_row_desc": "Odebrat řádek",
  "tinymce.table.desc": "Vložit tabulku",
  "tinymce.table.fixed_width": "Pevná šířka",
  "tinymce.table.fixed_width_tooltip": "Tažením okrajů sloupce nastavte šířku. Tabulka se vždy zobrazí s šířkou, kterou jste nastavili.",
  "tinymce.table.highlight_colour": "Barva zvýraznění",
  "tinymce.table.merge_cells_desc": "Sloučit buňky tabulky",
  "tinymce.table.more.heading": "Nastavení tabulky",
  "tinymce.table.numbering_column_desc": "Vložte sloupec číslování",
  "tinymce.table.paste_row_after_desc": "Vložit řádek za",
  "tinymce.table.paste_row_before_desc": "Vložte řádek tabulky",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Shift+V",
  "tinymce.table.responsive": "Responzivní",
  "tinymce.table.responsive_tooltip": "Sloupce tabulky se při přidávání obsahu rozšíří. Přetáhněte ohraničení sloupců pro relativní nastavení šířky vůči sobě navzájem a vůči stránce.",
  "tinymce.table.row": "Řádek",
  "tinymce.table.row_after_desc": "Vložit řádek za",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+â†“",
  "tinymce.table.row_before_desc": "Vložit řádek před",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+â†‘",
  "tinymce.table.row_highlight": "Řádek nadpisu",
  "tinymce.table.selection_highlight": "Změnit barvu buňky",
  "tinymce.table.split_cells_desc": "Rozdělit sloučené buňky tabulky",
  "tinymce.table_dlg.cols": "Sloupce",
  "tinymce.table_dlg.equal.width.columns": "Sloupce se stejnou šířkou",
  "tinymce.table_dlg.fullwidth": "Celá šířka",
  "tinymce.table_dlg.heading": "První řádek je nadpis",
  "tinymce.table_dlg.invalid_table_field": "Řady a sloupce musí být ve formě číslic větších než nula.",
  "tinymce.table_dlg.rows": "Řádky",
  "tinymce.table_dlg.sizetofit": "Velikost obsahu",
  "tinymce.table_dlg.title": "Vložit tabulku",
  "tinymce.table_dlg.width": "Šířka",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "Tabulka",
  "tinymce.tablepicker.insert_table_title": "Vložit tabulku",
  "tinymce.tablepicker.nested_table_unsupported": "Vnořené tabulky nejsou podporované.",
  "tinymce.tablepicker.pickerbox.tooltip": "Podržte klávesu SHIFT pro tabulku bez záhlaví.",
  "tinymce.templates.actions.defined": "Položky, které chcete vložit na tuto stránku.",
  "tinymce.templates.insert-template": "Šablona",
  "tinymce.templates.insert-template.tooltip": "Na tuto stránku vložte položky šablony.",
  "tinymce.templates.placeholder": "Instruktážní text",
  "tinymce.templates.placeholder.add": "Zástupný znak",
  "tinymce.templates.placeholder.add.tooltip": "Vložte na stránku textový zástupný symbol.",
  "tinymce.templates.placeholder.tooltip": "Zmizí, když uživatel píše a nezobrazuje se při prohlížení stránky.",
  "tinymce.templates.variables.add": "Nová proměnná",
  "tinymce.templates.variables.add.tooltip": "Přidejte na stránku nové pole, které vyplní uživatel šablony.",
  "tinymce.templates.variables.defined": "Proměnné k vložení na tuto stránku.",
  "tinymce.templates.variables.insert.tooltip": "Vložte do stránky pole '{'0'}', které pak vyplní uživatel šablony.",
  "tinymce.templates.variables.manage": "Spravujte proměnné",
  "tinymce.templates.variables.none": "Nebyly definovány žádné proměnné",
  "tinymce.templates.variables.none.tooltip": "Nebyly vytvořeny žádné proměnné.",
  "tinymce.tools.toolbar_item_hide": "Skrýt nástroje",
  "tinymce.tools.toolbar_item_hide_title": "Skrýt panely nástrojů",
  "tinymce.tools.toolbar_item_show": "Zobrazit nástroje",
  "tinymce.tools.toolbar_item_show_title": "Zobrazit panely nástrojů",
  "tinymce.web.css.resource.name": "Webové zdroje editoru CSS softwaru Confluence",
  "tinymce.web.js.resource.name": "Webové zdroje editoru Javascript softwaru Confluence",
  "tinymce.web.resource.name": "Zdroje webového editoru softwaru Confluence",
  "title.add.blogpost": "Přidat příspěvek na blog",
  "title.add.page": "Přidat stránku",
  "title.add.page.template": "Vytvořit šablonu",
  "title.comment": "Komentář",
  "title.dashboard": "Dashboard",
  "title.edit.page.template": "Upravit šablonu",
  "title.manage.groups": "Skupiny",
  "title.name": "Nadpis",
  "type.allcontent": "Zobrazit obsah",
  "unknown.file": "Soubor",
  "unsaved.comment.lost": "Váš komentář bude ztracen.",
  "unsaved.content.lost": "Může se stát, že provedené změny nebudou uloženy.",
  "unsaved.template.lost": "Neuložené změny šablon budou ztraceny.",
  "untitled.draft.title": "Bez názvu",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "Správa uživatelů",
  "usermanagement.parent.label": "Správa webu",
  "users.name": "Uživatelé",
  "view-changes-dialog.close.dialog": "Zavřít",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Nepublikované změny",
  "view.change": "zobrazit změnu",
  "view.profile": "Zobrazení profilu",
  "viewdrafts.page.desc": "Když upravujete stránku, ale nezveřejníte změny, vytvoří se koncept. Chcete-li pokračovat v úpravách nebo publikování změn, stiskněte tlačítko <b>Pokračovat</b>.",
  "welcome.message.edit": "Sdílejte užitečné odkazy, oznámení a informace zde",
  "welcome.message.edit.link": "Přizpůsobit",
  "word.file": "Dokument Microsoft Word",
  "word.template.file": "Šablona aplikace Microsoft Word",
  "word97.file": "Dokument Microsoft Word 97",
  "word97.template.file": "Šablona aplikace Microsoft Word 97",
  "xml.file": "Soubor XML",
  "yes.name": "Ano",
  "your.profile.and.settings": "Váš profil a nastavení.",
  "zip.file": "Archiv ZIP"
}